let stropheConnection = require('./stropheConnection.js');
let timeFormat = require('./timeformat.js');
let groupProfile = require('./groupProfile.js');
let audio = require('./audio.js');
let utils = require('./utils.js');
let trigger = require('./trigger.js');
let storage = require('./storage.js');
let userprofile = require('./userprofile.js');
let lastActivity = require('./lastActivity.js');
let timer;
let msgPageCount = 0;
let CurrentMessageId = '';
let load_page = "";
let scrollup_page = true;
let scrollpagedown = false;
let scrolldown_page = false;
let mediascroll = true;
let chathistory = 0;
let getChatType;
let language = require('./locale/language.js');
let mediaUrl = window._env_.ApiURL + "/media/";
let contact = require('./contact.js');
let vCard = require('./vCard.js');
const indexDb = require('./indexDb.js');
const userOncalls = require('./userOncalls.js');
const broadcastProfileJs = require('./broadcastProfile.js');
const webEncrypt  = require('./webchatEncryptDecrypt.js');

let firstContent,replytimer,scrollposition,msgType;

module.exports = {
    getSingleChat: function (jid, position, MessageId) {
        scrollposition = position;
        CurrentMessageId = MessageId;
        getChatType = "chat";
        (navigator.onLine) ? $('.loader').css("display", "block") : $('.loader').css("display", "none");
        (navigator.onLine) ? $(".recenttext").addClass('processing') : $(".recenttext").removeClass('processing');

        if ($('.loader').css('display') == 'block') {
            $('.loader').addClass(" innerpage-loader");
        }
        let randomValue = utils.cryptoRandomGenerate();

        let randomnumber = Math.floor(randomValue * (18 - 12 + 1)) + 12;
        let singlechatiq = stropheConnection.StropheJs().$iq({
            type: 'get',
            id: utils.randomString(randomnumber, 'A#!'),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            position: position,
            message_id: MessageId,
            status: "single_chat",
            to_user: jid
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(singlechatiq, module.exports.getSingleChatCallBack);
        }
    },
    getBroadcastChat: function (jid, position, MessageId) {
        CurrentMessageId = MessageId;
        
        (navigator.onLine) ? $('.loader').css("display", "block") : $('.loader').css("display", "none");
        (navigator.onLine) ? $(".recenttext").addClass('processing') : $(".recenttext").removeClass('processing');

        if ($('.loader').css('display') == 'block') {
            $('.loader').addClass(" innerpage-loader");
        }

        getChatType = "broadcast";
        let randomValue = utils.cryptoRandomGenerate();

        let randomnumber = Math.floor(randomValue * (16 - 12 + 1)) + 12;

        let broadcastiq = stropheConnection.StropheJs().$iq({
            type: 'get',
            id: utils.randomString(randomnumber, 'A#!'),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            position: position,
            message_id: MessageId,
            status: "broadcast_chat",
            to_user: jid
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(broadcastiq, module.exports.getSingleChatCallBack);
        }
    },
    getSingleChatCallBack: function (singlechatiq) {
        try {
            let divJid = stropheConnection.Strophe().getNodeFromJid(utils.toJID());
            let selector = $("[id='conversation"+divJid+"']");
            $(selector).off("scroll");
            $("[id='conversation"+divJid+"']").css({ height: "calc(100% - 135px)" });
            let today = utils.todayDate();
            $('.loader').css("display", "none");
            $(".recenttext").removeClass("processing")
            $('.loader').removeClass(" innerpage-loader");
            clearInterval(timer);
            let displaydate = '';
            let msgdate = "";
            let userJID = stropheConnection.logininfo.userJID;
            let ackDiv = '';
            let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');
            
            let usersProfileInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');

           

            if ($(singlechatiq).find('chat').length != 0) {
                let messagebody = "";
                let gsentstatus = "";
                let gdeliverstatus = "";
                let gseenstatus = "";
                let gackstatus = "";
                let grejstatus = "";
                $(singlechatiq).find('chat').each(function (index) {
                    chathistory = 1;
                    let dateString = $(this).find('time').text();
                    let time = timeFormat.convertTimestamp(dateString, 'created_at');

                    let dateTimeParts = dateString.split(' ');
                    let dateParts = dateTimeParts[0].split('-');
                    msgdate = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0];
                    let status = $(this).find('status').text();
                    let message_type = $(this).find('message_type').text();
                    let messageToNotification = $(this).find('message_to').text();

                    let recallstatus = $(this).find('recallstatus').text();
                    let favouritestatus = $(this).find('favouritestatus').text();
                    let favouriteby = $(this).find('favouriteby').text();

                    let broadcastid = $(this).find('broadcastid').text();
                    let broadcast_msgid = $(this).find('message').find('chatcontent').attr('broadcast_msgid')
                    broadcast_msgid = (typeof broadcast_msgid == 'undefined') ? '' : broadcast_msgid;
                    let message = $(this).find('message').text();
                    let msgid = $(this).find('msgid').text();
                    let amsgid = msgid;
                    let from = $(this).find('user').text();

                    gsentstatus = $(this).find('gsentstatus').text();
                    gdeliverstatus = $(this).find('gdeliverstatus').text();
                    gseenstatus = $(this).find('gseenstatus').text();
                    let totalMembers = (1 * gsentstatus) + (1 * gdeliverstatus) + (1 * gseenstatus);
                    gdeliverstatus = (1 * gdeliverstatus) + (1 * gseenstatus);
                    gackstatus = $(this).find('gackstatus').text();
                    grejstatus = $(this).find('grejstatus').text();

                    let msg_ack = $(this).find('msg_ack').text();
                    let ack_status = $(this).find('ack_status').text();

                    let msg_priority = $(this).find('message_priority').text();
                    let statusImage = "done_grey.webp";
                    
                    
                    if ($("[id='conversation"+divJid+"']").find('#chat-' + msgid).length == 0) {

                        messagebody = "";
                        let messageContent;
                        try {
                            if(message != '')
                            messageContent = JSON.parse(utils.decrypt(message, msgid));
                        }
                        catch (err) {
                            console.log(err);
                        }
                        let favourite = '';
                        let favoutirecontent;

                        if (broadcastProfile != null && typeof broadcastProfile[divJid] != "undefined" && broadcastProfile[divJid][0] == 'broadcast') {
                            favoutirecontent = '';
                            msgid = broadcast_msgid;
                        }else{
                            favoutirecontent = '<li role="presentation" class="favMenuDrop" id="fav-menu-' + msgid + '"><a  class="starmsg" >' + language.locali().star_message + '</a></li>';
                        }

                        if (favouritestatus == 2 || ( favouritestatus == 1 && favouriteby == userJID.toLowerCase() )) {
                            favourite = '<i class="fevorate"><svg version="1.1" viewBox="0 0 19.481 19.481"  enable-background="new 0 0 19.481 19.481"><g><path d="m10.201,.758l2.478,5.865 6.344,.545c0.44,0.038 0.619,0.587 0.285,0.876l-4.812,4.169 1.442,6.202c0.1,0.431-0.367,0.77-0.745,0.541l-5.452-3.288-5.452,3.288c-0.379,0.228-0.845-0.111-0.745-0.541l1.442-6.202-4.813-4.17c-0.334-0.289-0.156-0.838 0.285-0.876l6.344-.545 2.478-5.864c0.172-0.408 0.749-0.408 0.921,0z"/></g></svg></i>';
                            favoutirecontent = '<li role="presentation" id="fav-menu-' + msgid + '"><a  class="unstarmsg" >' + language.locali().unstar_message + '</a></li>';

                        }
                        let messageBodyContent = '';
                        if(message_type != 'notification'){
                            if(typeof messageContent != 'undefined'){

                                messageBodyContent = utils.checkMessageType(messageContent, msgid,msg_priority);
                            }else {
                                messageContent = ''
                            }
                        }else { // this condition only for Broadcast Msg Notification or Lable
                             messageBodyContent = utils.broadcastNotificationLablestatus( status, messageToNotification);
                             messageContent = '';

                        }

                       let filePath,ackStatus,deliveredStatus,readStatus,defaultcontent,messagedate;
                       let msgType = messageBodyContent[2];

                        if (recallstatus == 0) {

                            filePath = '';
                            if (msgType == 'audio' || msgType == 'video' || msgType == 'file' || msgType == 'image') {
                                filePath = '-' + messageContent.media.file_url;
                            }

                            if (msg_ack == 0) {
                                ackDiv = '';
                                ackStatus = "<span></span>";
                            } else if (msg_ack == 1) {
                                if (ack_status == 1) {
                                    ackDiv = '<span class="acknowledged">Acknowledged <i class="acknow"></i></span>';
                                    ackStatus = "<span class='ackStatus'>, Acknowledged</span>";
                                } else {
                                    ackDiv = '<div class="btn-merge"><span class="acknowledge ackClick">Tap to Acknowledge <i class="acknow"></i></span></div>';
                                    ackStatus = "<span class='ackStatus'>, Ack Pending</span>";
                                }
                            } else {
                                if (ack_status == 1) {
                                    ackDiv = '<span class="accepted">Accepted <i><img src="./src/images/Accept_ic.svg" alt="accept"/></i></span>';
                                    ackStatus = "<span class='ackStatus'>, Accepted</span>";
                                } else if (ack_status == 2) {
                                    ackDiv = '<span class="rejected">Rejected <i><img src="./src/images/Reject_ic.svg" alt="accept"/></i></span>';
                                    ackStatus = "<span class='ackStatus'>, Rejected</span>";
                                } else {
                                    ackDiv = '<div class="btn-merge"><span class="acknow-accept"><span>Accept</span><i><img src="./src/images/Accept_ic.svg" alt="accept"/></i></span><span class="acknow-reject"><span>Reject</span><i><img src="./src/images/Reject_ic.svg" alt="accept"/></i></span></div>';
                                    ackStatus = "<span class='ackStatus'>, Acc/Rej Pending</span>";
                                }
                            }
                            statusImage = "<span class='receiptStatus'>Sent</span>";
                            if (status == 1) {
                                statusImage = '<span class="receiptStatus">Delivered</span>';
                            } else if (status == 2) {
                                statusImage = '<span class="receiptStatus">Read</span>';
                            }

                            $(this).find('chatcontent').each(function (index) {
                                broadcastid = $(this).attr('broadcast_id');
                                if (broadcastid == stropheConnection.Strophe().getNodeFromJid(utils.toJID())) {
                                    msg_priority = 1;
                                    msgid = $(this).attr("broadcast_msgid");
    
                                    deliveredStatus = "<span> Del'd <span class='deliveredCount'>" + gdeliverstatus + "</span> of <span class='totDelCount'>" + totalMembers + "</span></span>";
    
                                    readStatus = "<span>, Read <span class='readCount'>" + gseenstatus + "</span> of <span id='totReadCount'>" + totalMembers + "</span></span>";
    
                                    statusImage = deliveredStatus + readStatus;
    
                                    if (msg_ack == 0) {
                                        ackStatus = '';
                                    } else if (msg_ack == 1) {
                                        ackStatus = "<span class='ackAccMainSpan'>, Ack'd <span class='ackCount'>" + gackstatus + "</span> of <span id='totAckCount'>" + totalMembers + "</span></span>";
                                    } else {
                                        ackStatus = "<span class='ackAccMainSpan'>, (Acc'd <span class='accCount'>" + gackstatus + "</span>, Rej'd <span class='rejCount'>" + grejstatus + "</span>) of <span id='totAckCount'>" + totalMembers + "</span></span>";
                                    }
                                }
                            });
                          
                            defaultcontent = '<div class="dropdown msg-opt convoDrop"> <a class="dropdown-toggle" id="menu1" type="button" data-toggle="dropdown">';
                            defaultcontent = defaultcontent + '<i class="option-arrow"></i></a>';
                            defaultcontent = defaultcontent + '<ul class="dropdown-menu head-option" role="menu" aria-labelledby="menu1">';

                            if (broadcastProfile != null && typeof broadcastProfile[divJid] != 'undefined') {

                                defaultcontent = defaultcontent + '<li role="presentation"><a  class="message-info" >' + language.locali().message_info + '</a></li>';
                            }else {
                                if(from == userJID){
                                    defaultcontent = defaultcontent + '<li role="presentation"><a  class="message-info" >' + language.locali().message_info + '</a></li>';

                                }
                            }

                            defaultcontent = defaultcontent + '<li role="presentation"><a  class="forwardsingle" id="' + messageBodyContent[2] + '">' + language.locali().forward + '</a></li>';


                            let now = new Date();
                            let currentUtc = new Date(now.toUTCString().slice(0, -4));
                            let d = new Date(dateString.replace(/-/g, "/"));
                            let differenceTravel = currentUtc.getTime() - d.getTime();
                            let datediff = Math.floor((differenceTravel) / (1000));


                            
                            if (from != userJID.toLowerCase()) {
                                if((msg_priority != 2 || (msg_priority == 2 && ack_status != 0))) {
                                    defaultcontent = defaultcontent + '<li role="presentation"><a  class="deletesingle" >' + language.locali().delete + '</a></li>';
                                }
                            } else {
                                if ($('#' + amsgid).length) {
                                    $('#' + amsgid).find('.list-msg-status').html(statusImage);
                                }
    
                                let settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');
                                let RecallTime = settings.recallTime;

                                if (datediff >= 0 && datediff < parseInt(RecallTime * 60)) {
                                    defaultcontent = defaultcontent + '<li role="presentation"><a  class="deletesingle" data-msgtime="' + dateString + '">' + language.locali().delete + '</a></li>';
                                } else {
                                    defaultcontent = defaultcontent + '<li role="presentation"><a  class="deletesingle" >' + language.locali().delete + '</a></li>';

                                }
                            }
                            
                            defaultcontent = defaultcontent + favoutirecontent;
                            if (divJid != storage.adminName() && ((usersProfileInfo != null && typeof usersProfileInfo[divJid] != "undefined" && usersProfileInfo[divJid][7] != "1") || (broadcastProfile != null && typeof broadcastProfile[divJid] != 'undefined'))) {
                                defaultcontent = defaultcontent + '<li role="presentation"><a  class="replysingle">' + language.locali().reply + '</a></li>';
                            }

                            defaultcontent = defaultcontent + "</ul></div>";

                        }
                        else {
                            defaultcontent = "";
                            filePath = "";
                            favourite = "";
                        }

                        if (from != userJID.toLowerCase()) {
                            let ChatAudioClass = '';
                            if(msgType == 'audio'){
                                ChatAudioClass = 'receiver-audio-main';
                            }

                            if (recallstatus == 1) {
                                msgType = "text";
                                
                                messageBodyContent[1] = '<div class="message-text main-deletemsg"><svg xmlns="http://www.w3.org/2000/svg" class = "deletedmsg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"/></svg><i class="text-italic deletedcontent">This message was deleted</i></div>';
                                messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-status="' + status + '" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="col-sm-12 message-main-receiver msg-continue"><span class="tail-receiver tail-msg-continue"></span><div class="receiver '+ChatAudioClass+'">'; 
                                
                                messagebody += messageBodyContent[1] + defaultcontent + ' <span class="message-time pull-right"><span class="msg-sent-time">'  + favourite + time + '</span>receive</span>' + ackDiv + '</div></div></div>';

                            } else {
                                let PriorityMsgClass = "";
                                if(typeof(msg_priority) != "undefined" && msg_priority == 2) {
                                    PriorityMsgClass = "priority-message-main"
                                }
                                messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-status="' + status + '" data-broadcastmsgid = "'+broadcast_msgid+'" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="select-msg-blk"><input type="checkbox" class="select-message" value="' + msgid + '-' + messageBodyContent[2] + filePath + '"><label></label></div><div class="col-sm-12 message-main-receiver msg-continue"><span class="tail-receiver tail-msg-continue"></span> <div class="receiver '+PriorityMsgClass+' '+ChatAudioClass+'">';
                                
                                if(typeof(msg_priority) != "undefined" && msg_priority == 2) {
                                    messagebody += '<div class="priority-message">' + language.locali().priority_message + '</div>';
                                } else if(typeof(msg_priority) != "undefined" && msg_priority == 0) {
                                    messagebody += '<div class="low-priority"><img class="low-priority-arrow" src="./src/images/svg/down-arrow-blue.svg" alt="low-priority"></div>';
                                }

                                messagebody += messageBodyContent[1] + defaultcontent + ' <span class="message-time pull-right"><span class="msg-sent-time">' + favourite + time + '</span></span>' + ackDiv + '</div></div></div>';;
                            }
                            if (status == 0) {
                                module.exports.sendDeliverStatus(from, msgid);
                                
                                module.exports.sendSeenStatus(from, msgid, msg_priority, msg_ack, divJid,broadcast_msgid);
                            }
                            else if (status == 1) {
                                if(index == 0) {
                                    module.exports.sendSeenStatus(from, msgid, msg_priority, msg_ack, divJid,broadcast_msgid);

                                }
                            }

                        } else {

                            if (recallstatus == 1) {
                                msgType = "text";
                                messageBodyContent[1] = '<div class="message-text main-deletemsg"><svg xmlns="http://www.w3.org/2000/svg" class = "deletedmsg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z" fill="#B9B9B9"/></svg><i class="text-italic deletedcontent">You deleted this message</i></div>';
                                messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-broadcastmsgid = "'+broadcast_msgid+'" data-message_id = "'+amsgid+'" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="col-sm-12 message-main-sender msg-continue"> <span class="tail-sender tail-msg-continue"></span><div class="sender deletesender">';

                                messagebody += messageBodyContent[1] + defaultcontent + ' <span class="message-time"><span class="msg-sent-time pull-right" data-msgtime="'+dateString+'"   >' + time + '</span></span></div></div></div>';
                            } else {
                                
                                messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-broadcastmsgid = "'+broadcast_msgid+'" data-message_id = "'+amsgid+'" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="select-msg-blk"><input type="checkbox" class="select-message" value="' + msgid + '-' + messageBodyContent[2] + filePath + '"><label></label></div><div class="col-sm-12 message-main-sender msg-continue"> <span class="tail-sender tail-msg-continue"></span><div class="sender">';

                                if(typeof(msg_priority) != "undefined" && msg_priority == 2) {
                                    messagebody += '<div class="priority-message">' + language.locali().priority_message + '</div>';
                                } else if(typeof(msg_priority) != "undefined" && msg_priority == 0) {
                                    messagebody += '<div class="low-priority"><img class="low-priority-arrow" src="./src/images/svg/down-arrow-white.svg" alt="low-priority"></div>';
                                }

                                messagebody += messageBodyContent[1] + defaultcontent + ' <span class="message-time"> <span class="msg-sent-time pull-right" data-msgtime="'+dateString+'">' + favourite +  time + '</span><span class="msg-status-sign">' + statusImage + '</span><span class="ackType">' + ackStatus + '</span></span></div></div></div>';
                            }
                        }
                        if (recallstatus == 0) {
                            if (typeof messageContent.replyTo != "undefined" && messageContent.replyTo != '') {

                                module.exports.getReplyMessage(msgid, messageContent.replyTo, 'chat');
                            }
                        }
                        if (msgdate != displaydate && displaydate != "") {
                            if (displaydate == today) {
                                if ($("[id='conversation"+divJid+"']").find('#' + today).length != 0) {
                                    $("[id='conversation"+divJid+"']").find('#' + today).remove();
                                }
                                messagedate = '<div class="row message-previous current message-date" id ="' + today + '"><div class="col-sm-12  previous"><a>Today</a></div></div>';
                                $("[id='conversation"+divJid+"']").prepend(messagedate);
                            } else {

                                if (scrollposition == "down") {

                                    if ($("[id='conversation"+divJid+"']").find('#' + displaydate).length != 0) {
                                        $("[id='conversation"+divJid+"']").find('#' + displaydate).remove();
                                    }
                                    messagedate = '<div class="row message-previous message-date" id = "' + displaydate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                                    if(timeFormat.getyesterday(displaydate) != 'Invalid Date'){

                                        $("[id='conversation"+divJid+"']").prepend(messagedate);
                                    }
                                }
                                if (scrollposition == "up") {

                                    if ($("[id='conversation"+divJid+"']").find('#' + displaydate).length == 0) {

                                        messagedate = '<div class="row message-previous message-date" id = "' + displaydate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                                    if(timeFormat.getyesterday(displaydate) != 'Invalid Date'){

                                        $("[id='conversation"+divJid+"']").prepend(messagedate);
                                    }
                                    }
                                }
                            }

                        }
                        if(message_type == 'notification' && (broadcastProfile != null && typeof broadcastProfile[divJid] != "undefined" && broadcastProfile[divJid][0] == 'broadcast')){

                            messagebody = '<div id = "notify-' + msgid + '" class="row message-previous"><div class="col-sm-12 previous"><a>' + messageBodyContent + '</a></div></div>';
                        }
                        
                        displaydate = msgdate;
                        if (scrollposition == "up") {
                            
                            $("[id='conversation"+divJid+"']").prepend(messagebody);
                            scrollup_page = true;
                        }else if(scrollposition == "down" && CurrentMessageId == ''){
                            $("[id='conversation"+divJid+"']").prepend(messagebody);
                            scrolldown_page = false;

                        }
                        else {
                            if (displaydate == today) {
                                if ($("[id='conversation"+divJid+"']").find('#' + today).length == 0) {
                                    messagedate = '<div class="row message-previous current message-date" id ="' + today + '"><div class="col-sm-12  previous"><a>Today</a></div></div>';
                                    $("[id='conversation"+divJid+"']").append(messagedate);
                                }
                            }
                            else {
                                if ($("[id='conversation"+divJid+"']").find('#' + displaydate).length == 0) {
                                    messagedate = '<div class="row message-previous message-date" id = "' + displaydate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                                    if(timeFormat.getyesterday(displaydate) != 'Invalid Date'){
                                        $("[id='conversation"+divJid+"']").append(messagedate);
                                    }
                                }
                            }
                            msgPageCount = 1;
                            if(CurrentMessageId == ''){
                                $("[id='conversation"+divJid+"']").prepend(messagebody);
                            }else {

                                $("[id='conversation"+divJid+"']").append(messagebody);
                            }
                            if (!firstContent) {
                                scrollup_page = true;
                            }
                            scrolldown_page = true;
                        }
                        if (msgType == "image" || msgType == "video") {
                            utils.mediadesign(msgType, msgid);

                        }
                    } else {
                        if (CurrentMessageId == msgid && (scrollposition == "" || scrollposition == "down")) {
                            scrolldown_page = false;
                            $(".downarrow").hide();

                        }
                    }
                });

                if (CurrentMessageId != '') {
                    if ($("#chat-" + CurrentMessageId).length || $('[data-message_id="'+CurrentMessageId+'"]').length) {

                        let container = $("[id='conversation"+divJid+"']");
                        if (typeof starMsgId != "undefined" && starMsgId != "" && scrollposition == "up") {

                            scrollTo = $("#chat-" + starMsgId);


                        } else {
                            if (broadcastProfile != null && typeof broadcastProfile[divJid] != "undefined" && broadcastProfile[divJid][0] == 'broadcast') {
                                scrollTo = $('[data-message_id="'+CurrentMessageId+'"]');
                            }else {

                                scrollTo = $("#chat-" + CurrentMessageId);
                            }

                        }
                        container.scrollTop(scrollTo.offset().top - container.offset().top + container.scrollTop());

                    }
                }
                $(document).ready(function () {
                    $(document).unbind().on("click", ".pButton", function () {
                        let nodeJid = $(this).attr('id');
                        let result = nodeJid.split("-");
                        audio.audioDesign(result[0]);
                    });
                });
               
                if (CurrentMessageId != '' && $(singlechatiq).find('chat').length < 20 && scrolldown_page && scrollpagedown) {

                    let selector = $("[id='conversation"+divJid+"']");
                    if (typeof $(selector).find(".message-body").first().attr('id') != "undefined") {
                        let result = $(selector).find(".message-body").first().attr('id').split("-");
                        let messageId = result[1];

                        setTimeout(function () {
                            let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
                            if (broadcastProfile != null && typeof broadcastProfile[stropheConnection.Strophe().getNodeFromJid(toJID)] != "undefined" && broadcastProfile[stropheConnection.Strophe().getNodeFromJid(toJID)][0] == 'broadcast') {
                                module.exports.getBroadcastChat(toJID, 'up', messageId);
                            } else {
                                module.exports.getSingleChat(toJID, 'up', messageId);
                            }
                        }, 2000);
                    }
                } else {
                    module.exports.pagination();
                    let textValue = $("#comment").html();
                    if (textValue == "" || textValue == null) {
                        $("#send-icon").css("display", "none");
                        $("#microphone").css("display", "block");
                    } else {
                        $("#send-icon").css("display", "block");
                        $("#microphone").css("display", "none");
                    }
                }
                if ($(singlechatiq).find('chat').length < 20) {
                    let messagedate;
                    if (displaydate == today) {
                        if ($("[id='conversation"+divJid+"']").find('#' + today).length != 0) {
                            $("[id='conversation"+divJid+"']").find('#' + today).remove();
                        }
                        messagedate = '<div class="row message-previous current message-date" id ="' + today + '"><div class="col-sm-12  previous"><a>Today</a></div></div>';
                        $("[id='conversation"+divJid+"']").prepend(messagedate);
                    } else {
                        $("[id='"+displaydate+"']").remove();

                        if (scrollposition == "down") {
                            if (displaydate != '' && $("[id='conversation"+divJid+"']").find('#' + displaydate).length != 0) {
                                $("[id='conversation"+divJid+"']").find('#' + displaydate).remove();
                            }
                            messagedate = '<div class="row message-previous message-date" id = "' + displaydate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                            if(timeFormat.getyesterday(displaydate) != 'Invalid Date'){
                                $("[id='conversation"+divJid+"']").prepend(messagedate);
                            }
                            
                        }
                        if (scrollposition == "up") {
                            scrollup_page = false;

                            if ($("[id='conversation"+divJid+"']").find('#' + displaydate).length == 0) {

                                messagedate = '<div class="row message-previous message-date" id = "' + displaydate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                                if(timeFormat.getyesterday(displaydate) != 'Invalid Date'){


                                    $("[id='conversation"+divJid+"']").prepend(messagedate);
                                }
                            }
                        }
                    }
                    if (scrollposition == "up" && getChatType == 'broadcast') {
                        scrollup_page = false;
                    }
                }   
                if (chathistory == 0) {
                    $('.select-messages').hide();
                    $('.contact-clearmsg').hide();
                }
                if ($('.select-msg-blk').is(':visible')) {
                    $(".select-messages").trigger('click');
                }
                module.exports.mediaviewClick();
                utils.forwardmsg();
                utils.determineDropDirection();

            } else {
                if (scrollposition == "up") {
                    scrollup_page = false;
                    let messagebody;
                    if ($("[id='conversation"+divJid+"']").find('.current').length && msgdate == today) {
                        if ($("[id='conversation"+divJid+"']").find('#' + today).length) {
                            $("[id='conversation"+divJid+"']").find('#' + today).remove();
                        }
                        messagebody = '<div class="row message-previous current message-date"  id ="' + today + '"><div class="col-sm-12  previous"><a>Today</a></div></div>';
                        $("[id='conversation"+divJid+"']").prepend(messagebody);
                    }
                    else if (msgdate != "") {
                        if ($("[id='conversation"+divJid+"']").find('#' + msgdate).length) {
                            $("[id='conversation"+divJid+"']").find('#' + msgdate).remove();
                        }
                        messagebody = '<div class="row message-previous  message-date" id ="' + msgdate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(msgdate) + '</a></div></div>';
                        $("[id='conversation"+divJid+"']").prepend(messagebody);
                    }


                }else if (scrollposition == ""||scrollposition == "down") {

                    scrolldown_page = false;
                    $(".downarrow").hide();
                }
                if (getChatType == "broadcast" && scrollposition == "up") {
                    scrollup_page = false;
                    let messagebody = '<div class="row message-previous"><div class="col-sm-12 previous"><a>Broadcast Created</a></div></div>';
                    $("[id='conversation"+divJid+"']").prepend(messagebody);
                }
                module.exports.pagination()

            }
            let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');

            if (broadcastProfile != null && typeof broadcastProfile[stropheConnection.Strophe().getNodeFromJid(toJID)] != "undefined" && broadcastProfile[stropheConnection.Strophe().getNodeFromJid(toJID)][0] == 'broadcast') {
                $('.invitation_div').hide()
            
            }
            if (msgPageCount == 0) {
                
                utils.scrollbottom("[id='conversation"+divJid+"']");

            }
            msgPageCount = 1;

        } catch (err) {
            console.log("getSingleChatCallBack", err);
            console.log('getSingleChatCallBack', singlechatiq);
        }
        return true;
    },
    getGroupChat: function (jid, position, MessageId) {
        scrollposition = position;
        CurrentMessageId = MessageId;
        (navigator.onLine) ? $('.loader').css("display", "block") : $('.loader').css("display", "none");
        (navigator.onLine) ? $(".recenttext").addClass('processing') : $(".recenttext").removeClass('processing');

        if ($('.loader').css('display') == 'block') {
            $('.loader').addClass(" innerpage-loader");
        }
        let randomValue = utils.cryptoRandomGenerate();

        let randomnumber = Math.floor(randomValue * (15 - 12 + 1)) + 12;
        let groupchatiq = stropheConnection.StropheJs().$iq({
            type: 'get',
            id: utils.randomString(randomnumber, 'a#!'),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            position: position,
            message_id: MessageId,
            status: "group_chat",
            to_user: jid
        });
        if (stropheConnection.Connection().connected) {

            stropheConnection.Connection().sendIQ(groupchatiq, module.exports.getGroupChatCallBack);
        }
    },
    getGroupChatCallBack: function (groupchathistory) {
        try {
            let divJid = stropheConnection.Strophe().getNodeFromJid(utils.toJID());
            let selector = $("[id='conversation"+divJid+"']");
            $(selector).off("scroll");
            $(selector).css({ height: "calc(100% - 135px)" });
            let today = utils.todayDate();
            $('.message-info').off('click');
            $('.loader').css("display", "none");
            $(".recenttext").removeClass("processing")
            $('.loader').removeClass(" innerpage-loader");
            let userJID = stropheConnection.logininfo.userJID;
            clearInterval(timer);
            if (typeof firstContent == 'undefined') {
                firstContent = false;
            }
            let msgdate = "";
            let displaydate = "";
            let messagebody = "";
            let messagedate;
            if ($(groupchathistory).find('query').text() != "No chats available") {
                let sendername = "";
                let sendermsgid = "";
                $(groupchathistory).find('chat').each(function (index) {
                    chathistory = 1;
                    let status,ackDiv,messageContent,messageBodyContent;
                    let dateString = $(this).find('time').text();
                    let time = timeFormat.convertTimestamp($(this).find('time').text(), 'created_at');

                    /** Convet UTC time To Local Start **/
                        dateString = utils.convertUtcToLocal(dateString);
                    /** Convet UTC time To Local END **/

                    let msgid = $(this).find('msgid').text();
                    let msgtype = $(this).find('msgtype').text();
                    let from = $(this).find('user').text();
                    status = $(this).find('status').text();
                    let to_user = $(this).find('to_user').text();

                    let messageFromNotification = $(this).find('message_from').text();
                    let messageToNotification = $(this).find('message_to').text();
                    let recallstatus = $(this).find('recallstatus').text();

                    let fromUser = $(this).find('fromuser').text();

                    let message = $(this).find('body').text();
                    let dateTimeParts = dateString.split(' ');
                    let dateParts = dateTimeParts[0].split('-');
                    msgdate = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0];

                    let favouritestatus = $(this).find('favouriteby').text();
                    let tonotification = from;
                    let msgnotification = message;

                    //get total members
                    let gsentstatus = $(this).find('gsentstatus').text();
                    let gdeliverstatus = $(this).find('gdeliverstatus').text();
                    let gseenstatus = $(this).find('gseenstatus').text();
                    let totalMembers = (1 * gsentstatus) + (1 * gdeliverstatus) + (1 * gseenstatus);
                    gdeliverstatus = (1 * gdeliverstatus) + (1 * gseenstatus);
                    try {
                        messageContent = JSON.parse(utils.decrypt(message, msgid));
                        let messageConvFrom = messageContent.message_from;
                        if (messageConvFrom == 'Switchboard' && stropheConnection.Strophe().getNodeFromJid(from) == '123456789' ){
                            totalMembers = totalMembers + 1;
                        }
                    }
                    catch (err) {

                    }
                    let deliveredStatus = "<span>Del'd <span class='deliveredCount'>" + gdeliverstatus + "</span> of <span id='totDelCount'>" + totalMembers + "</span></span>";
                    let readStatus = '<span>, Read <span class="readCount">' + gseenstatus + '</span> of <span id="totReadCount">' + totalMembers + '</span></span>';

                    let msg_priority = $(this).find('message_priority').text();

                    //get ack type
                    let msg_ack = $(this).find('msg_ack').text();
                    let ack_status = $(this).find('ack_status').text();
                    let gackstatus = $(this).find('gackstatus').text();
                    let grejstatus = $(this).find('grejstatus').text();
                    let ackStatus,favourite,favoutirecontent,filePath,defaultcontent;
                    if (msg_ack == 0) {
                        ackStatus = '';
                        ackDiv = '';
                    } else if (msg_ack == 1) {
                        if (ack_status == 1) {
                            ackDiv = '<span class="acknowledged">Acknowledged <i class="acknow"></i></span>';
                        } else {
                            ackDiv = '<div class="btn-merge"><span id="' + from + '" class="acknowledge ackClick">Tap to Acknowledge <i class="acknow"></i></span></div>';
                        }
                        ackStatus = "<span class='ackAccMainSpan'>Ack'd <span class='ackCount'>" + gackstatus + "</span> of <span id='totAckCount'>" + totalMembers + "</span></span>";
                    } else {
                        if (ack_status == 1) {
                            ackDiv = '<span class="accepted">Accepted <i><img src="./src/images/Accept_ic.svg" alt="accept"/></i></span>';
                        } else if (ack_status == 2) {
                            ackDiv = '<span class="rejected">Rejected <i><img src="./src/images/Reject_ic.svg" alt="accept"/></i></span>';
                        } else {
                            ackDiv = '<div class="btn-merge"><span id="' + from + '" class="acknow-accept"><span>Accept</span><i><img src="./src/images/Accept_ic.svg" alt="accept"/></i></span><span id="' + from + '" class="acknow-reject"><span>Reject</span><i><img src="./src/images/Reject_ic.svg" alt="accept"/></i></span></div>';
                        }
                        ackStatus = "<span class='ackAccMainSpan'>(Acc'd <span class='accCount'>" + gackstatus + "</span>, Rej'd <span class='rejCount'>" + grejstatus + "</span>) of <span id='totAckCount'>" + totalMembers + "</span></span>";
                    }


                    messagebody = "";
                    if (msgtype != 0) {

                        if ($('#chat-' + msgid).length == 0) {


                            messageContent = '';
                            messageBodyContent = '';
                            let messageConvFrom = '';
                            try {

                                messageContent = JSON.parse(utils.decrypt(message, msgid));
                                messageBodyContent = utils.checkMessageType(messageContent, msgid,msg_priority);
                                messageConvFrom = messageContent.message_from;
                            }
                            catch (err) {
                                
                                console.log(err);
                            }

                            if (recallstatus == 0) {

                                favourite = '';
                                favoutirecontent = '<li role="presentation" id="fav-menu-' + msgid + '"><a  class="starmsg" >' + language.locali().star_message + '</a></li>';

                                if (favouritestatus == 1) {
                                    favourite = '<i class="fevorate"><svg version="1.1" viewBox="0 0 19.481 19.481" enable-background="new 0 0 19.481 19.481"><g><path d="m10.201,.758l2.478,5.865 6.344,.545c0.44,0.038 0.619,0.587 0.285,0.876l-4.812,4.169 1.442,6.202c0.1,0.431-0.367,0.77-0.745,0.541l-5.452-3.288-5.452,3.288c-0.379,0.228-0.845-0.111-0.745-0.541l1.442-6.202-4.813-4.17c-0.334-0.289-0.156-0.838 0.285-0.876l6.344-.545 2.478-5.864c0.172-0.408 0.749-0.408 0.921,0z"></path></g></svg></i>';
                                    favoutirecontent = '<li role="presentation" id="fav-menu-' + msgid + '"><a  class="unstarmsg" >' + language.locali().unstar_message + '</a></li>';

                                }


                                filePath = '';
                                msgType = messageBodyContent[2];
                                if (msgType == 'audio' || msgType == 'video' || msgType == 'file' || msgType == 'image') {
                                    filePath = '-' + messageContent.media.file_url;
                                }

                                defaultcontent = '<div class="dropdown msg-opt convoDrop"> <a class="dropdown-toggle" id="menu1" type="button" data-toggle="dropdown">';
                                defaultcontent = defaultcontent + '<i class="option-arrow"></i></a>';
                                defaultcontent = defaultcontent + '<ul class="dropdown-menu head-option" role="menu" aria-labelledby="menu1">';
                                defaultcontent = defaultcontent + '<li role="presentation"><a  class="message-info" >' + language.locali().message_info + '</a></li>';
                                defaultcontent = defaultcontent + '<li role="presentation"><a  class="forwardsingle" id="' + messageBodyContent[2] + '">' + language.locali().forward + '</a></li>';
                                if((msg_priority != 2 || (msg_priority == 2 && ack_status != 0))) {
                                    defaultcontent = defaultcontent + '<li role="presentation"><a  class="deletesingle">' + language.locali().delete + '</a></li>';
                                }
                                defaultcontent = defaultcontent + favoutirecontent;
                                defaultcontent = defaultcontent + '<li role="presentation"><a  class="replysingle">' + language.locali().reply + '</a></li>';
                                defaultcontent = defaultcontent + '</ul></div>';
                            } else {

                                filePath = "";
                                defaultcontent = "";

                            }
                            let displayName,Fromusername,statusImage;
                            if (fromUser != userJID && fromUser != "") {
                                statusImage =  ackStatus;

                                displayName = messageConvFrom;
                                Fromusername = messageConvFrom;
                                
                                if (sendername == displayName) {
                                    $('#chat-' + sendermsgid).find(".receiver").find('.receivefrom').remove();
                                }
                                let ChatAudioClass;
                                if(msgType == 'audio'){
                                    ChatAudioClass = 'receiver-audio-main';
                                }

                                if (recallstatus == 1) {
                                    messageBodyContent[1] = '<div class="message-text main-deletemsg"><svg xmlns="http://www.w3.org/2000/svg" class = "deletedmsg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"/></svg><i class="text-italic deletedcontent">This message was deleted</i></div>';

                                    messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-status="' + status + '" data-fromuser="'+messageContent.message_from+'" data-msgfrom="' + fromUser + '"><div class="col-sm-12 message-main-receiver msg-continue"><span class="tail-receiver tail-msg-continue"></span><div class="receiver ' + messageBodyContent[2] + '-attachment' + '  '+ChatAudioClass+'"><a class="receivefrom">' + Fromusername + '</a>' + messageBodyContent[1] + defaultcontent + ' <span class="message-time pull-right"><span class="msg-status-sign" style="padding: 5px">' + statusImage + '</span><span class="msg-sent-time">' + time + '</span></span></div></div></div>' + messagebody;

                                } else {

                                    if(typeof(msg_priority) != "undefined" && msg_priority == 2) {
                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-status="' + status + '" data-fromuser="'+messageContent.message_from+'" data-msgfrom="' + fromUser + '" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="select-msg-blk"><input type="checkbox" class="select-message" value="' + msgid + '-' + messageBodyContent[2] + filePath + '"><label></label></div><div class="col-sm-12 message-main-receiver msg-continue"><span class="tail-receiver tail-msg-continue"></span><div class="receiver ' + messageBodyContent[2] + '-attachment' + '  '+ChatAudioClass+' priority-message-main"><div class="priority-message">' + language.locali().priority_message + '</div><a class="receivefrom">' + Fromusername + '</a>' + messageBodyContent[1] + defaultcontent + ' <span class="message-time pull-right"><span class="msg-status-sign" style="padding: 5px">' + statusImage + '</span><span class="msg-sent-time">' + favourite + time + '</span></span>' + ackDiv + '</div></div></div>' + messagebody;
                                    } else if(typeof(msg_priority) != "undefined" && msg_priority == 0) {
                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-status="' + status + '" data-fromuser="'+messageContent.message_from+'" data-msgfrom="' + fromUser + '" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="select-msg-blk"><input type="checkbox" class="select-message" value="' + msgid + '-' + messageBodyContent[2] + filePath + '"><label></label></div><div class="col-sm-12 message-main-receiver msg-continue"><span class="tail-receiver tail-msg-continue"></span><div class="receiver ' + messageBodyContent[2] + '-attachment' + '  '+ChatAudioClass+'"><div class="low-priority"><img class="low-priority-arrow" src="./src/images/svg/down-arrow-blue.svg" alt="low-priority"></div><a class="receivefrom">' + Fromusername + '</a>' + messageBodyContent[1] + defaultcontent + ' <span class="message-time pull-right"><span class="msg-status-sign" style="padding:5px">' + statusImage + '</span><span class="msg-sent-time">' + favourite + time + '</span></span>' + ackDiv + '</div></div></div>' + messagebody;
                                    } else {
                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-status="' + status + '" data-fromuser="'+messageContent.message_from+'" data-msgfrom="' + fromUser + '" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="select-msg-blk"><input type="checkbox" class="select-message" value="' + msgid + '-' + messageBodyContent[2] + filePath + '"><label></label></div><div class="col-sm-12 message-main-receiver msg-continue"><span class="tail-receiver tail-msg-continue"></span><div class="receiver ' + messageBodyContent[2] + '-attachment' + '  '+ChatAudioClass+'"><a class="receivefrom">' + Fromusername + '</a>' + messageBodyContent[1] + defaultcontent + ' <span class="message-time pull-right"><span class="msg-status-sign" style="padding: 5px">' + statusImage + '</span><span class="msg-sent-time">' + favourite + time + '</span></span>' + ackDiv + '</div></div></div>' + messagebody;
                                    }
                                    sendermsgid = msgid;
                                }


                                sendername = displayName;

                                if (status == 1) {
                                    module.exports.sendSeenStatus(fromUser, msgid, msg_priority, msg_ack, divJid);
                                } else if (status == 0) {
                                    module.exports.sendDeliverStatus(fromUser, msgid);
                                    setTimeout(function () {
                                        module.exports.sendSeenStatus(fromUser, msgid, msg_priority, msg_ack, divJid);
                                    }, 2000);
                                }
                            } else {
                                if(ackStatus == ''){
                                    statusImage = deliveredStatus + readStatus + ackStatus;

                                }else {
                                    statusImage = deliveredStatus + readStatus + ', '+ ackStatus;

                                }

                                if (recallstatus == 0) {
                                    let now = new Date();
                                    let currentUtc = new Date(now.toUTCString().slice(0, -4));
                                    let d = new Date(dateString.replace(/-/g, "/"));

                                    let differenceTravel = currentUtc.getTime() - d.getTime();

                                    let datediff = Math.floor((differenceTravel) / (1000));


                                    defaultcontent = '<div class="dropdown msg-opt convoDrop"> <a class="dropdown-toggle" id="menu1" type="button" data-toggle="dropdown">';
                                    defaultcontent = defaultcontent + '<i class="option-arrow"></i></a>';
                                    defaultcontent = defaultcontent + '<ul class="dropdown-menu head-option" role="menu" aria-labelledby="menu1">';
                                    defaultcontent = defaultcontent + '<li role="presentation"><a  class="message-info" >' + language.locali().message_info + '</a></li>';
                                    defaultcontent = defaultcontent + '<li role="presentation"><a  class="forwardsingle" id="' + messageBodyContent[2] + '">' + language.locali().forward + '</a></li>';

                                    let settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');
                                    let RecallTime = settings.recallTime;

                                    if (datediff >= 0 && datediff < parseInt(RecallTime * 60)) {
                                        defaultcontent = defaultcontent + '<li role="presentation"><a  class="deletesingle" data-msgtime="' + dateString + '">' + language.locali().delete + '</a></li>';
                                    } else {
                                        defaultcontent = defaultcontent + '<li role="presentation"><a  class="deletesingle">' + language.locali().delete + '</a></li>';
                                    }
                                    
                                    defaultcontent = defaultcontent + '<li role="presentation"><a  class="replysingle">' + language.locali().reply + '</a></li>';
                                    defaultcontent = defaultcontent + favoutirecontent;
                                    defaultcontent = defaultcontent + '</ul></div>';

                                    if(typeof(msg_priority) != "undefined" && msg_priority == 2) {

                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="select-msg-blk"><input type="checkbox" class="select-message" value="' + msgid + '-' + messageBodyContent[2] + filePath + '"><label></label></div><div class="col-sm-12 message-main-sender msg-continue"><span class="tail-sender tail-msg-continue"></span> <div class="sender"><div class="priority-message">' + language.locali().priority_message + '</div>' + messageBodyContent[1] + defaultcontent + ' <span class="message-time"><span class="msg-sent-time pull-right" data-msgtime="'+dateString+'">' + favourite + time + '</span><span class="msg-status-sign">' + statusImage + '</span></span></div></div></div>' + messagebody;

                                    } else if(typeof(msg_priority) != "undefined" && msg_priority == 0) {

                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="select-msg-blk"><input type="checkbox" class="select-message" value="' + msgid + '-' + messageBodyContent[2] + filePath + '"><label></label></div><div class="col-sm-12 message-main-sender msg-continue"><span class="tail-sender tail-msg-continue"></span> <div class="sender"><div class="low-priority"><img class="low-priority-arrow" src="./src/images/svg/down-arrow-white.svg" alt="low-priority"></div>' + messageBodyContent[1] + defaultcontent + ' <span class="message-time"><span class="msg-sent-time pull-right" data-msgtime="'+dateString+'">' + favourite + time + '</span><span class="msg-status-sign">' + statusImage + '</span></span></div></div></div>' + messagebody;

                                    } else {
                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="select-msg-blk"><input type="checkbox" class="select-message" value="' + msgid + '-' + messageBodyContent[2] + filePath + '"><label></label></div><div class="col-sm-12 message-main-sender msg-continue"><span class="tail-sender tail-msg-continue"></span> <div class="sender">' + messageBodyContent[1] + defaultcontent + ' <span class="message-time"><span class="msg-sent-time pull-right" data-msgtime="'+dateString+'">'+ favourite + time + '</span><span class="msg-status-sign">' + statusImage + '</span></span></div></div></div>' + messagebody;
                                    }
                                }
                                else {

                                    defaultcontent = "";
                                    favourite = "";
                                    messageBodyContent[1] = '<div class="message-text main-deletemsg"><svg xmlns="http://www.w3.org/2000/svg" class = "deletedmsg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z" fill="#B9B9B9"/></svg><i class="text-italic deletedcontent">You deleted this message</i></div>';

                                    if(typeof(msg_priority) != "undefined" && msg_priority == 2) {

                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="col-sm-12 message-main-sender msg-continue"><span class="tail-sender tail-msg-continue"></span> <div class="sender deletesender"><div class="priority-message">' + language.locali().priority_message + '</div>' + messageBodyContent[1] + defaultcontent + ' <span class="message-time"><span class="msg-sent-time pull-right" data-msgtime="'+dateString+'">' + favourite + time + '</span></span></div></div></div>' + messagebody;

                                    } else if(typeof(msg_priority) != "undefined" && msg_priority == 0) {

                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="col-sm-12 message-main-sender msg-continue"><span class="tail-sender tail-msg-continue"></span> <div class="sender deletesender"><div class="low-priority"><img class="low-priority-arrow" src="./src/images/svg/down-arrow-white.svg" alt="low-priority"></div>' + messageBodyContent[1] + defaultcontent + ' <span class="message-time"><span class="msg-sent-time pull-right" data-msgtime="'+dateString+'">' + favourite + time + '</span></span></div></div></div>' + messagebody;

                                    } else {
                                        messagebody = '<div class="row message-body" id="chat-' + msgid + '" data-fromuser="'+messageContent.message_from+'" data-priority="' + msg_priority + '" data-ack="' + msg_ack+ '"><div class="col-sm-12 message-main-sender msg-continue"><span class="tail-sender tail-msg-continue"></span> <div class="sender deletesender">' + messageBodyContent[1] + defaultcontent + ' <span class="message-time"><span class="msg-sent-time pull-right" data-msgtime="'+dateString+'">' + favourite + time + '</span></span></div></div></div>' + messagebody;
                                    }
                                }
                                sendername = "";

                            }

                            if (msgdate != "" && msgdate != displaydate && displaydate != "") {

                                if (displaydate == today) {
                                    if ($("[id='conversation"+divJid+"']").find('#' + today).length != 0) {
                                        $("[id='conversation"+divJid+"']").find('#' + today).remove();
                                    }
                                    messagedate = '<div class="row message-previous current message-date" id = "' + today + '"><div class="col-sm-12 previous"><a>Today</a></div></div>';
                                } else {
                                    if ($("[id='conversation"+divJid+"']").find('#' + displaydate).length != 0) {
                                        $("[id='conversation"+divJid+"']").find('#' + displaydate).remove();
                                    }
                                    messagedate = '<div class="row message-previous message-date" id = "' + displaydate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                                }

                                if(timeFormat.getyesterday(displaydate) != 'Invalid Date'){
                                    $("[id='conversation"+divJid+"']").prepend(messagedate);
                                }

                            }

                            if (scrollposition == "up") {

                                $("[id='conversation"+divJid+"']").prepend(messagebody);
                                let container = $("[id='conversation"+divJid+"']"),
                                scrollTo = $("#chat-" + CurrentMessageId);
                                container.scrollTop(scrollTo.offset().top - container.offset().top + container.scrollTop());

                            }else if(CurrentMessageId == '' && scrollposition == "down"){
                                $("[id='conversation"+divJid+"']").prepend(messagebody);

                            }
                            else {
                                scrolldown_page = true;
                                scrollup_page = true;


                                msgPageCount = 1;
                                $("[id='conversation"+divJid+"']").append(messagebody);
                            }

                            if (!firstContent) {

                                scrollup_page = true;
                            }
                            if (recallstatus == 0) {
                                if (typeof messageContent.replyTo != "undefined" && messageContent.replyTo != '') {
                                    module.exports.getReplyMessage(msgid, messageContent.replyTo, "normal");
                                }

                            }
                        } else {

                            if (CurrentMessageId == msgid && scrollposition == "") {

                                scrolldown_page = false;
                                scrollup_page = true;
                                $(".downarrow").hide();

                            }
                            if (!firstContent) {
                                scrollup_page = true;
                            }
                        }
                        if (messageContent.message_type == "image" || messageContent.message_type == "video") {
                            utils.mediadesign(messageContent.message_type, msgid);
                        }
                    } else {
                        sendername = "";
                        let nmsgbody = msgnotification;

                        if ($('#notify-' + msgid).length == 0) {
                            $('.tempNotificationLable').remove();
                            if (msgdate != displaydate && displaydate != "") {

                                if (displaydate == today) {
                                    if ($("[id='conversation"+divJid+"']").find('#' + today).length != 0) {
                                        $("[id='conversation"+divJid+"']").find('#' + today).remove();
                                    }
                                    messagedate = '<div class="row message-previous message-date current" id="' + today + '"><div class="col-sm-12  previous"><a>Today</a></div></div>';
                                } else {
                                    if ($("[id='conversation"+divJid+"']").find('#' + displaydate).length != 0) {
                                        $("[id='conversation"+divJid+"']").find('#' + displaydate).remove();
                                    }

                                    messagedate = '<div class="row message-previous message-date" id="' + displaydate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                                }
                                if(timeFormat.getyesterday(displaydate) != 'Invalid Date'){
                                    $("[id='conversation"+divJid+"']").prepend(messagedate);
                                }
                            }
                            let groupid = stropheConnection.Strophe().getNodeFromJid(utils.toJID());
                            let msgcontent = utils.groupstatus(groupid, fromUser, tonotification, nmsgbody, messageFromNotification, messageToNotification,to_user);

                            if (( msgcontent != "" && nmsgbody != 2 && nmsgbody != 3 && nmsgbody != 4 && nmsgbody != 5 ) || (msgcontent != "" && (nmsgbody == 2 || nmsgbody == 3 || nmsgbody ==4 || nmsgbody ==5))) {
                                if (nmsgbody == 1) {
                                    messagebody = '<div id = "notify-' + msgid + '" class="row message-previous newgroup"><div class="col-sm-12 previous"><a>' + msgcontent + '</a></div></div>';
                                } else {
                                    messagebody = '<div id = "notify-' + msgid + '" class="row message-previous"><div class="col-sm-12 previous"><a>' + msgcontent + '</a></div></div>';
                                }
                                if (scrollposition == "up") {

                                    $("[id='conversation"+divJid+"']").prepend(messagebody);

                                }else if(CurrentMessageId == '' && scrollposition == "down"){
                                    $("[id='conversation"+divJid+"']").prepend(messagebody);

                                }
                                else {
                                    msgPageCount = 1;
                                    scrolldown_page = true;
                                    $("[id='conversation"+divJid+"']").append(messagebody);
                                }
                            }
                            if (nmsgbody == 1) {
                                firstContent = true;
                                scrollup_page = false;

                                if ($("[id='conversation"+divJid+"']").find('.current').length && msgdate == today) {
                                    if ($("[id='conversation"+divJid+"']").find('#' + today).length != 0) {
                                        $("[id='conversation"+divJid+"']").find('#' + today).remove();
                                    }
                                    messagedate = '<div class="row message-previous current message-date" id="' + today + '"><div class="col-sm-12  previous"><a>Today</a></div></div>';
                                } else if (msgdate != "") {
                                    if ($("[id='conversation"+divJid+"']").find('#' + msgdate).length != 0) {
                                        $("[id='conversation"+divJid+"']").find('#' + msgdate).remove();
                                    }
                                    messagedate = '<div class="row message-previous message-date" id="' + msgdate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                                }
                                if(timeFormat.getyesterday(displaydate) != 'Invalid Date'){
                                    if (scrollposition == "up") {
                                        $("[id='conversation"+divJid+"']").prepend(messagedate);
    
                                    }else if(CurrentMessageId == '' && scrollposition == "down"){
                                        $("[id='conversation"+divJid+"']").prepend(messagedate);
    
                                    }else{
    
                                        $("[id='conversation"+divJid+"']").append(messagedate);
                                    }
                                }
                          
                            }

                            if (!firstContent) {
                                scrollup_page = true;
                            }
                        }
                    }
                    displaydate = msgdate;
                });
                $(document).ready(function () {
                    $(document).unbind().on("click", ".pButton", function () {
                        let nodeJid = $(this).attr('id');
                        let result = nodeJid.split("-");
                        audio.audioDesign(result[0]);
                    });
                })
                
                
                if (msgPageCount == 0) {
                    utils.scrollbottom("[id='conversation"+divJid+"']");
                }


                displaydate = msgdate;
                if (displaydate == today) {
                    if ($("[id='conversation"+divJid+"']").find('#' + today).length != 0) {
                        $("[id='conversation"+divJid+"']").find('#' + today).remove();
                    }
                    messagebody = '<div class="row message-previous current" id ="' + today + '"><div class="col-sm-12 previous"><a>Today</a></div></div>';
                } else {
                    if ($("[id='conversation"+divJid+"']").find('#' + displaydate).length != 0) {
                        $("[id='conversation"+divJid+"']").find('#' + displaydate).remove();
                    }
                    messagebody = '<div class="row message-previous" id ="' + displaydate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(displaydate) + '</a></div></div>';
                }

                $("[id='conversation"+divJid+"']").prepend(messagebody);



                msgPageCount = 1;
               
                if ($(groupchathistory).find('chat').length < 20) {
                    if ($("[id='conversation"+divJid+"']").find('.newgroup').length == 0) {
                        messagebody = '<div class="row message-previous newgroup"><div class="col-sm-12 previous"><a>Team created</a></div></div>';
                        
                        $("[id='conversation"+divJid+"']").prepend(messagebody);

                    }
                }
                if (CurrentMessageId != '' && $(groupchathistory).find('chat').length < 20 && scrolldown_page && scrollpagedown && scrollposition != 'up') {
                    selector = $("[id='conversation"+divJid+"']");
                    if (typeof $(selector).find(".message-body").last().attr('id') != "undefined") {
                        let result = $(selector).find(".message-body").first().attr('id').split("-");
                        let messageId = result[1];

                        setTimeout(function () {
                            let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
                            module.exports.getGroupChat(toJID, 'up', messageId);
                        }, 2000);
                    }
                } else {
                    module.exports.pagination();
                    let textValue = $("#comment").html();
                    if (textValue == "" || textValue == null) {
                        $("#send-icon").css("display", "none");
                        $("#microphone").css("display", "block");
                    } else {
                        $("#send-icon").css("display", "block");
                        $("#microphone").css("display", "none");
                    }

                }
                if (chathistory == 0) {
                    $('.select-messages').hide();
                    $('.contact-clearmsg').hide();
                }
                if ($('.select-msg-blk').is(':visible')) {
                    $(".select-messages").trigger('click');
                }
                module.exports.mediaviewClick();
                utils.forwardmsg();
                utils.determineDropDirection();
            } else {
                if (scrollposition == "") {
                    scrolldown_page = false;
                    $(".downarrow").hide();
                } else if (scrollposition == "up") {
                    scrollup_page = false;
                    firstContent = true;
                }

                $("[id='conversation"+divJid+"']").find('.newgroup').remove();
                if ($("[id='conversation"+divJid+"']").find('.newgroup').length == 0) {
                    
                    $("[id='conversation"+divJid+"']").prepend(messagebody);

                } else {
                    if ($("[id='conversation"+divJid+"']").find('.current').length && msgdate == today) {
                        if ($("[id='conversation"+divJid+"']").find('#' + today).length != 0) {
                            $("[id='conversation"+divJid+"']").find('#' + today).remove();
                        }
                        messagebody = '<div class="row message-previous current" id = "' + today + '"><div class="col-sm-12  previous"><a>Today</a></div></div>';
                    } else if (msgdate != "") {
                        if ($("[id='conversation"+divJid+"']").find('#' + msgdate).length != 0) {
                            $("[id='conversation"+divJid+"']").find('#' + msgdate).remove();
                        }
                        messagebody = '<div class="row message-previous" id= "' + msgdate + '"><div class="col-sm-12 previous"><a>' + timeFormat.getyesterday(msgdate) + '</a></div></div>';
                    }
                    $("[id='conversation"+divJid+"']").prepend(messagebody);
                }
                module.exports.pagination()

            }

        } catch (err) {
            console.log("getGroupChatCallBack", err);
            console.log("getGroupChatCallBack iq", groupchathistory);
        }
        
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        
        if(typeof groupInfo != 'undefined' && typeof groupInfo[divJid] != 'undefined' && groupInfo[divJid][4] === "2") {
            $(".row.reply.reply-box").show()
            $(".row.reply.reply-box").css('display','flex')
        }
        return true;
    },
    getSingleChatMedia: function (toJID, MessageId) {
        let randomValue = utils.cryptoRandomGenerate();

        let randomnumber = Math.floor(randomValue * (16 - 12 + 1)) + 12;
        mediascroll = true;
        let groupchatmediaiq = stropheConnection.StropheJs().$iq({
            type: 'get',
            id: utils.randomString(randomnumber, 'A#'),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            status: "single_chat_media",
            message_id: MessageId,
            to_user: toJID
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(groupchatmediaiq, module.exports.getSingleChatMediaCallBack);
        }
    },
    getBroadcastChatMedia: function (toJID, MessageId) {
        let randomValue = utils.cryptoRandomGenerate();

        let randomnumber = Math.floor(randomValue * (16 - 12 + 1)) + 12;
        mediascroll = true;
        let groupchatmediaiq = stropheConnection.StropheJs().$iq({
            type: 'get',
            id: utils.randomString(randomnumber, 'A#'),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            message_id: MessageId,
            status: "broadcast_chat_media",
            to_user: toJID
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(groupchatmediaiq, module.exports.getSingleChatMediaCallBack);
        }
    },
    getSingleChatMediaCallBack: function (sinlgechatmedia) {
        try {
            clearInterval(timer);
            if ($(sinlgechatmedia).find('chat').length) {
                let messageBodyContent = "";
                let BigContent = '';
                let msg_id,msgbody;
                $(sinlgechatmedia).find('chat').each(function (index) {
                    let msgid = $(this).find('msgid').text();
                    msg_id = $(this).find('msg_id').text();
                    $(".media-gallery-empty").css("display", "none");
                    msgbody = $(this).find('body').text();
                    let messageContent = JSON.parse(utils.decrypt(msgbody, msgid));
                    messageBodyContent = utils.getMediaurls(messageContent, msgid);
                    BigContent += messageBodyContent;

                });
                if (typeof msg_id != "undefined") {
                    if (msg_id == '') {
                        $("#media-small-view").html("");
                        $("#media-small-view").html(BigContent);
                        $("#media-full-view").html("");
                        $("#media-full-view").html(BigContent);
                    } else {
                        $("#media-full-view").append(BigContent);
                    }
                    module.exports.mediaviewClick();
                }

            } else {
                mediascroll = false;
                let mediamsgid;
                $(sinlgechatmedia).find('query').each(function (index) {
                    mediamsgid = $(this).attr('message_id');
                });
                if (mediamsgid == "") {
                    $("#media-full-view").html("");
                    $(".media-gallery-empty").css("display", "block");
                    $("#media-small-view").html("");
                    $("#media-full-view").html('<div class="media-detail-body">No Media and Docs</div>');

                } else {
                    if ($("#media-full-view").html() == '') {
                        $(".media-gallery-empty").css("display", "block");
                        $("#media-small-view").html("");
                        $("#media-full-view").html('<div class="media-detail-body">No Media and Docs</div>');
                    }
                }
            }
        } catch (err) {
            console.log("getSingleChatMediaCallBack", err);
            console.log("getSingleChatMediaCallBack iq", sinlgechatmedia);
        }
        return true;
    },
    mediaviewClick: function () {
        
        $('.media-canvas-component').on("click", function (event) {
            let url = $(this).find('p').attr('src');
            let type = $(this).find('p').attr('type');
            let msgId = $(this).find('p').attr('data-msg-id');
            let userToken = storage.getuserToken();
            let videoUrl,duration;
            $('.prof-big').addClass(type);
            $('.content').find('.prof-big').find('img').attr('src', '');
            if (type == "image") {
                $('.popup').find('.popup-head').find('img').css('display', 'block');
                $('.popup').find('.prof-big').find('img').css('display', 'block');
                $('.popup').find('.popup-head').find('video').css('display', 'none');
                $('.popup').find('.prof-big').find('video').css('display', 'none');
                $('.popup').find('.prof-big').find('#audiocontent').css('display', 'none');
                $('.popup').find('.popup-head').find('img').attr('src', url);
                $('.content').find('.prof-big').find('img').attr('src', url);
                indexDb.blobImageConversion(url,'.prof-big img',msgId,'chatImages');

            } else if (type == "video") {
                let fileName = $(this).attr('data-media-file');
                url = mediaUrl + fileName + "?mf=" + userToken;
                
                $('.popup').find('.popup-head').find('img').css('display', 'none');
                $('.popup').find('.prof-big').find('img').css('display', 'none');
                $('.popup').find('.popup-head').find('video').css('display', 'block');
                $('.popup').find('.prof-big').find('video').css('display', 'block');
                $('.popup').find('.prof-big').find('#audiocontent').css('display', 'none');
                $('.popup').find('.popup-head').find('video').attr('src', url);
                videoUrl = url;
                $('.content').find('.prof-big').find('video').attr('src', '');
                indexDb.videoBlobConversion(videoUrl,'#videocontent');
            } else if (type == "audio") {
                duration = $(this).find('p').attr('length');
                $('.popup').find('.popup-head').find('img').css('display', 'block');
                $('.popup').find('.prof-big').find('img').css('display', 'none');
                $('.popup').find('.popup-head').find('video').css('display', 'none');
                $('.popup').find('.prof-big').find('video').css('display', 'none');
                $('.popup').find('.prof-big').find('#audiocontent').css('display', 'block');
                $('.popup').find('.popup-head').find('img').attr('src', 'src/images/audio.webp');
                indexDb.blobImageConversion(url,'#audioview-music source',msgId,'chatAudios');

                $('.content').find('.prof-big').find('#audioview-music source').attr('src', url);
                let audio = $("#audioview-music")[0];
                audio.load();
                $('.popup').find('.prof-big').find('#audiocontent').find('#audioview-tracktime').html(duration);
            } else if (type == "file") {
                window.open(url, '_blank');
            }
            if (type != "file") {
                $('#popup-full').css('visibility', 'visible');
                $('#popup-full').css('opacity', '1');
            }

           setTimeout(function () {
            $('#audioview-playhead').removeAttr('style');
           }, 0);

        });
    },
    getGroupChatMedia: function (toJID, MessageId) {
        let randomValue = utils.cryptoRandomGenerate();

        let randomnumber = Math.floor(randomValue * (15 - 12 + 1)) + 12;
        mediascroll = true;
        let groupchatmediaiq = stropheConnection.StropheJs().$iq({
            type: 'get',
            id: utils.randomString(randomnumber, 'Aa#'),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            status: "group_chat_media",
            message_id: MessageId,
            to_user: toJID
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(groupchatmediaiq, module.exports.getGroupChatMediaCallBack);
        }
    },
    getGroupChatMediaCallBack: function (groupchatmedia) {
        try {
            clearInterval(timer);
            if ($(groupchatmedia).find('groupchat').length != 0) {
                let BigContent = "";
                let msg_id;
                $(".media-gallery-empty").css("display", "none");

                $(groupchatmedia).find('groupchat').each(function (index) {
                    let msgid = $(this).find('msgid').text();
                    msg_id = $(this).find('msg_id').text();

                    $(".media-gallery-empty").css("display", "none");

                    let msgbody = $(this).find('body').text();

                    if (msgbody != "") {
                        let messageContent = JSON.parse(utils.decrypt(msgbody, msgid));
                        let messageBodyContent = utils.getMediaurls(messageContent, msgid);
                        BigContent += messageBodyContent;
                    }

                });
                if (typeof msg_id != "undefined") {
                    if (msg_id == '') {
                        $("#media-small-view").html("");
                        $("#media-small-view").html(BigContent);
                        $("#media-full-view").html("");
                        $("#media-full-view").html(BigContent);
                    } else {
                        $("#media-full-view").append(BigContent);
                    }
                }
                module.exports.mediaviewClick();



            } else {
                mediascroll = false;
                if ($("#media-full-view").html() == '') {
                    $(".media-gallery-empty").css("display", "block");
                    $("#media-small-view").html("");
                    $("#media-full-view").html('<div class="media-detail-body">No Media and Docs</div>');
                }
            }
        } catch (err) {
            console.log('getGroupChatMediaCallBack', err);
            console.log("getGroupChatMediaCallBack iq", groupchatmedia);
        }
    },
    paginationScrollFirst: function(userid,toJID,scrollposition,messageId){
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

        timer = setTimeout(function () {
            if (userInfo != null && typeof userInfo[userid] != "undefined") {
                module.exports.getSingleChat(toJID, scrollposition, messageId);
            } else if (groupInfo != null && typeof groupInfo[userid] != "undefined") {
                module.exports.getGroupChat(toJID, scrollposition, messageId);
            } else if (broadcastProfile != null && typeof broadcastProfile[userid] != "undefined") {
                module.exports.getBroadcastChat(toJID, scrollposition, messageId);
            }
        }, 1000);
    },
    paginationScrollSecond:function(toJID,scrollposition,messageId){
        timer = setTimeout(function () {
            module.exports.getGroupChat(toJID, scrollposition, messageId);
        }, 1000);
    },
    paginationGetLoadPage:function(userid){
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

        let load_page;
        if (userInfo != null && typeof userInfo[userid] != "undefined") {
            load_page = "chat";
        } else if (groupInfo != null && typeof groupInfo[userid] != "undefined") {
            load_page = "group";
        } else if (broadcastProfile != null && typeof broadcastProfile[userid] != "undefined") {
            load_page = "broadcast";
        }
        return load_page;
    },
    paginationScrollThird: function(load_page,toJID,scrollposition,messageId){
        timer = setTimeout(function () {
            if (load_page == 'chat') {
                module.exports.getSingleChat(toJID, scrollposition, messageId);
            } else if (load_page == 'group') {
                module.exports.getGroupChat(toJID, scrollposition, messageId);
            } else if (load_page == 'broadcast') {
                module.exports.getBroadcastChat(toJID, scrollposition, messageId);
            }
        }, 1000);
    },
    pagination: function () {
        let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
        let divJid = stropheConnection.Strophe().getNodeFromJid(utils.toJID());
        let selector = $("[id='conversation"+divJid+"']");
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');


        $(selector).on('scroll', function () {
            let result;
            if ($(selector).scrollTop() == 0 && scrollup_page && selector.html() != '') {
                scrollposition = "up";
                scrollpagedown = true;
                $(".dropdown").removeClass("open");
                let userid = stropheConnection.Strophe().getNodeFromJid(utils.toJID());
                let messageId;
                if (typeof $(selector).find(".message-body").last().attr('id') != "undefined") {
                    
                    if (broadcastProfile != null && typeof broadcastProfile[userid] != "undefined") {
                        messageId = $(selector).find(".message-body").first().attr('data-message_id');

                    }else {
                        result = $(selector).find(".message-body").first().attr('id').split("-");
 
                        messageId = result[1];
                    }
                    module.exports.paginationScrollFirst(userid,toJID,scrollposition,messageId)
                } else if (typeof $(selector).find(".message-previous").last().attr('id') != "undefined") {
                    result = $(selector).find(".message-previous").first().attr('id').split("-");
                    messageId = result[1];
                    module.exports.paginationScrollSecond(toJID,scrollposition,messageId)
                }
            } else if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight-1 && scrolldown_page && selector.html() != '') {
                $(".dropdown").removeClass("open");
                let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
                scrollposition = "down";
                scrollpagedown = false;
                let userid = stropheConnection.Strophe().getNodeFromJid(toJID);
                load_page = module.exports.paginationGetLoadPage(userid);

                if (typeof $(selector).find(".message-body").last().attr('id') != "undefined") {
                    result = $(selector).find(".message-body").last().attr('id').split("-");
                    let messageId = result[1];
                    module.exports.paginationScrollThird(load_page,toJID,scrollposition,messageId)
                }
                setTimeout(() => {
                    
                    utils.msgBoxDivHeight();
                }, 2000);
            }
        });

        let mediaselector = $('.media-canvas-table');

        $(mediaselector).on('scroll', function () {
            let result;
            if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight && mediascroll) {
                let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
                let userid = stropheConnection.Strophe().getNodeFromJid(toJID);
                load_page = module.exports.mediaSelectorFirstSplit(userid);
                if (typeof $(mediaselector).find(".media-canvas-component").last().attr('id') != "undefined") {
                    result = $(mediaselector).find(".media-canvas-component").last().attr('id').split("-");

                    let messageId = result[1];
                    module.exports.mediaSelectorSecondSplit(load_page,toJID,messageId);
                }
            }

        });
    },
    mediaSelectorFirstSplit:function(userid){
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');


        let load_page;
        if (userInfo != null && typeof userInfo[userid] != "undefined") {
            load_page = "chat";
        } else if (groupInfo != null && typeof groupInfo[userid] != "undefined") {
            load_page = "group";
        } else if (broadcastProfile != null && typeof broadcastProfile[userid] != "undefined") {
            load_page = "broadcast";
        }

        return load_page;
    },
    mediaSelectorSecondSplit: function(load_page,toJID,messageId){
        timer = setTimeout(function () {
            if (load_page == 'chat') {
                module.exports.getSingleChatMedia(toJID, messageId);
            } else if (load_page == 'group') {
                module.exports.getGroupChatMedia(toJID, messageId);
            } else if (load_page == 'broadcast') {
                module.exports.getBroadcastChatMedia(toJID, messageId);
            }
        }, 1000);
    },

    MessageLayout: function (jid, sposition, messageId) {
        try {
        $('.chat-option').removeClass('menu');
        $('.plus-circles').css('display', 'block');
        $('#message').find('#right-side-prof').css('display','block')
        $('#message').find('#singleChatRightsideProf').css('display','none')
        $('.heading-info').hide();
        let mediaUrl = window._env_.ApiURL + "/media/";  
        let userJid = stropheConnection.Strophe().getNodeFromJid(jid);
        let nodeJid = stropheConnection.Strophe().getNodeFromJid(jid);
        let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');

        msgPageCount = 0;
        let Icon = '';
        let imageExtArray = ['jpg','jpeg','png','webp'];
        let profileExtention;

        scrollup_page = true;
        scrolldown_page = true;
        scrollpagedown = true;
        $(".reply-content").hide();
        firstContent = false;
        $(".downarrow").hide();
        scrollposition = sposition;
        let divJid = stropheConnection.Strophe().getNodeFromJid(jid);
        $('.msglist').hide();
        $("#media-full-view").html("");
        $("#media-small-view").html("");
        $('.select-messages').show();
        $('.contact-clearmsg').show();
        $(".acknowledge-icon").show();
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

        if ($('.select-msg-blk').is(':visible')) {
            $(".select-messages").trigger('click');
        }
        $("#comment").focus();
        let userToken = storage.getuserToken();
        $("#media-full-link").off("click");
        if($('.profile-pager').html()){
            $("#pager_right").css("display", "block");
        }else{
            $("#pager_right").css("display", "none");
        }
        $("#media-full-link").click(function () {

            $(".side-frd-profile").css({ 
               " right": "calc(-100% + 316px)", 
                "width": "316px" 
            });
            $(".media-detail-section").css({
                "width": "100%",
                "top": "-100%",
                "right": "0%"
            });
            $("#userprofile").css({
                "right": "-100%",
                "width": "30%",
                "top": "-100%",
                "display": "none"
            });
            $(".infohead").css({
                "display": "none",
            });
            let mediaselector = $('.media-canvas-table');

            if (typeof $(mediaselector).find(".media-canvas-component").last().attr('id') != "undefined") {
                let result = $(mediaselector).find(".media-canvas-component").last().attr('id').split("-");

                messageId = result[1];
                timer = setTimeout(function () {
                    if (jid.indexOf('mix.') != -1) {

                        module.exports.getGroupChatMedia(toJID, messageId);
                    } else {
                        let id = stropheConnection.Strophe().getNodeFromJid(jid);
                        if (broadcastProfile != null && typeof broadcastProfile[id] != "undefined" && broadcastProfile[id][0] == 'broadcast') {

                            module.exports.getBroadcastChatMedia(toJID, messageId);
                        } else {
                            module.exports.getSingleChatMedia(toJID, messageId);
                        }
                    }
                }, 1000);
            }
        });
        $('#comment').attr("data-text", "Start typing...");
        $('#comment').empty();
        $("#replyemoji").show();
        $("#microphone").show();
        $("#send-icon").hide();
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let offlineText = webEncrypt.getFromLocalStorageAndDecrypt('offlineText');
        if (offlineText != null && typeof offlineText[userJid] != "undefined") {
            if (offlineText[userJid][0] == "chatcontent") {
                $("#comment").html(offlineText[userJid][1]);
                $("#microphone").hide();
                $("#send-icon").show();
            }
        }
        let isChatUser = $('.mCSB_container').children("[id='roster-"+userJid+"']").data('id');
        let isUnregisterUser = $('.mCSB_container').children("[id='roster-"+userJid+"']").data('isunregister');
        let profilename,blockUserInfo,profileimage;
        if (userInfo != null && typeof userInfo[userJid] != "undefined") {
            $('#right-side-prof').attr("src","src/images/avatar/chat/profile_img_one.svg");
            module.exports.updateuserprofile(userJid);
            $('.audio-video-cont').show();
            profilename = userInfo[userJid][1] ? utils.toTitleCase(userInfo[userJid][1]) : '';
            blockUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('blockUserInfo');
            
            profileimage = userInfo[userJid][2];

            if(typeof profileimage != 'undefined') {
                profileExtention = profileimage.split('.').pop();
                if(utils.getHexRegexPattern().test(profileimage)) 
                    profileimage = userInfo[userJid][2];
                else if (profileimage !== 'src/images/avatar/chat/profile_img_one.svg' && profileimage.trim() !== '')
                    profileimage = mediaUrl + profileimage + "?mf=" + userToken;
                else if (profileimage.trim() == '') 
                    profileimage = "src/images/avatar/chat/profile_img_one.svg";
            }else {
                profileimage = "src/images/avatar/chat/profile_img_one.svg";
                profileExtention = '';
            }
           

            $('.heading-attach').show();
            $('.reply-recording').show();
            $('.emojiPickerIconWrap').show();
            $("#message .heading-dot").show();

            if (userInfo[userJid][4] == "emailcontact") 
                $(".heading-avatar-icon").find(".notify-msg-contact").show();
            else 
                $(".heading-avatar-icon").find(".notify-msg-contact").hide();

            if (blockUserInfo != null && typeof blockUserInfo[userJid] != "undefined") {
                $(".block-con").hide();
                $(".unblock-con").show();
                $(".blocked-person").text("Can't send a message to blocked contact " + minEmoji(profilename));
                $('.heading-attach').hide();
                $(".row.reply").css("display", "none");
                $(".blocked-person").css("display", "block");
                $("#replyemoji").hide();
                $("#microphone").hide();
            } else {
                $(".unblock-con").hide();
                if (userJid == storage.adminName() || userInfo[userJid][7] == "1" || userInfo[userJid][16] == "1") {
                    if(userInfo[userJid][11] != ''){
                        $("#pager_right").show();
                    }
                    $('.reply-recording').hide();
                    $('.heading-attach').hide();
                    $("#message .heading-dot").hide();
                    $(".blocked-person").text(language.locali().get_alias_conv_content);
                    $(".blocked-person").css("display", "block");
                    $(".row.reply").css("display", "none");
                    $('.emojiPickerIconWrap').hide();
                    $('.reply-recording').hide();
                } 
           
            }

        } else if (groupInfo != null && typeof groupInfo[userJid] != "undefined") {
            $("#pager_right").css("display", "none");
            $('#right-side-prof').attr("src","src/images/avatar/group/group_four.svg");
            $('.invitation_div').css('display','none!important')
            $('.audio-video-cont').hide();
            $(".heading-avatar-icon").find(".notify-msg-contact").hide();
            profilename = groupInfo[userJid][1];
            profileimage = groupInfo[userJid][2];

            if(utils.getHexRegexPattern().test(profileimage)) 
                profileimage = groupInfo[userJid][2];
            else if (profileimage !== 'src/images/avatar/group/group_four.svg' && profileimage.trim() !== '') 
                profileimage = mediaUrl + profileimage + "?mf=" + userToken;
            else if (profileimage.trim() == '') 
                profileimage = "src/images/avatar/group/group_four.svg";

            
                if(groupInfo[userJid][4] === "2") {
                   let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails')
                   let userJID = stropheConnection.logininfo.userJID;

                    let grpUsers = [];
                    grpUsers = module.exports.updateuserprofGetGrpUser(grpUsers,groupDetail,userJid)
                    let grpMem = module.exports.updateuserprofGetGrpMem(grpUsers,userJID)
                    
                    if(!grpMem){
                        $('.reply-recording').hide();
                        $('.heading-attach').hide();
                        $("#message .heading-dot").hide();
                        $(".blocked-person").text("You cannot send messages to alerts");
                        $(".blocked-person").css("display", "block");
                        $(".row.reply").css("display", "none");
                        $('.emojiPickerIconWrap').hide();
                        $('.acknowledge-icon').show();

                    }else{
                        $('.reply-recording').show();
                        $('.heading-attach').show();
                        $("#message .heading-dot").show();
                        $(".row.reply").css("display", "block");
                        $('.emojiPickerIconWrap').show();
                        $('.acknowledge-icon').show();
                    }


                    
                }
        } else if (broadcastProfile != null && typeof broadcastProfile[userJid] != "undefined") {
            $('.invitation_div').css('display','none!important');
            $("img.right-side-prof").css("display", "block");
            $('#message .heading-avatar-icon div').first().attr('src','')
            $(".color-code").css("display", "none");
            module.exports.updateuserprofile(userJid);
            $('.audio-video-cont').hide();
            profilename = broadcastProfile[userJid][1];
            profileimage = broadcastProfile[userJid][2];
            if (profileimage !== 'src/images/avatar/broadcast/profile_img_one.png' && profileimage !== '') 
                profileimage = mediaUrl + profileimage + "?mf=" + userToken;
            else if (profileimage.trim() == '') 
                profileimage = "src/images/avatar/broadcast/profile_img_one.png";
            
            $('.heading-attach').show();
            $('.reply-recording').show();
            $('.emojiPickerIconWrap').show();
            $("#message .heading-dot").show();
            $(".heading-avatar-icon").find(".notify-msg-contact").hide();
        } else {
            profilename = "";
            profileimage = "";
            webEncrypt.encryptAndStoreInLocalStorage('isUnknown', true);
            userprofile.getUserProfile(userJid);
        }

        if(utils.getHexRegexPattern().test(profileimage)) {
            let colorCode = utils.hexToRgbA(profileimage);
            $("img.right-side-prof").css("display", "none");
            $('#message .heading-avatar-icon div').first().attr('src','')
            $(".color-code").css("display", "block");
            $(".color-code").css("background-color", colorCode);
            
            if (userInfo != null && typeof userInfo[nodeJid] != "undefined") {
                let onCallIcon = userInfo[nodeJid][14];
                let fillColor = userInfo[nodeJid][14]?utils.hexToRgbA(userInfo[nodeJid][15].trim()):"#fff";
                let iconBgcolor = profileimage.substring(profileimage.lastIndexOf('/') + 1).replace(/\?.+/, '')
                Icon = this.getIcon(onCallIcon,iconBgcolor,fillColor);
                $('#message').find('.right-side-prof').html(Icon);
            }
        } else {

            $("img.right-side-prof").css("display", "block");
            $(".color-code").css("display", "none");
            if(groupInfo && typeof groupInfo[nodeJid] != "undefined"){
                let onCallIcon = groupInfo[nodeJid][7];
                let fillColor = groupInfo[nodeJid][8]?utils.hexToRgbA(groupInfo[nodeJid][8]):"#fff";
                let iconBgcolor = profileimage.substring(profileimage.lastIndexOf('/') + 1).replace(/\?.+/, '')
                Icon = this.getIcon(onCallIcon,iconBgcolor,fillColor);
                $('#message').find('.right-side-prof').attr('src', profileimage);
                if(profileimage !== "src/images/avatar/group/group_four.svg" &&profileimage.trim() !== ''){
                    indexDb.blobImageConversion(profileimage,'#message #right-side-prof',nodeJid,'profileImages');
                 }

                $('#message').find('.right-side-prof').attr('src', profileimage);
                $('#message .heading-avatar-icon div').first().attr('src','')

            } else if(userInfo != null && typeof userInfo[nodeJid] != "undefined") {
                let concatedLetter;
                let name = userInfo[nodeJid][1];
                concatedLetter = userprofile.userProHandleGetConcatImgTxt(name);

                if(typeof profileimage != 'undefined' && profileimage !== 'src/images/avatar/chat/profile_img_one.svg' && profileimage.trim() !== '' && imageExtArray.includes(profileExtention)){
                    $('#message').find('#singleChatRightsideProf').css('display','none');
                    $('#message').find('#right-side-prof').css('display','block')
                    $('#message').find('#right-side-prof').attr('src', profileimage);
                    $('#message .heading-avatar-icon div').first().attr('src','')

                    $('#message').find('#right-side-prof').attr('src', profileimage).on("error", function() {
                        $('#message').find('#right-side-prof').css('display','none')
                        $('#message').find('#singleChatRightsideProf').children().remove();
                        $('#message').find('#singleChatRightsideProf').css('display','block');
                        
                        let tempNodeJid = $("#rightSideHeaderId").val();
                        if(userInfo[tempNodeJid][7] != 1){
                        
                            $('#message').find('#singleChatRightsideProf').append('<div class="avatar-icon"><svg id="rightSideSvgprof" class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="height:50px;width:50px;margin-top:0px !important"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700;">'+concatedLetter+'</text></svg></div>');
                        }
                    });
                }else {
                    $('#message').find('#right-side-prof').css('display','none')
                    $('#message').find('#singleChatRightsideProf').children().remove();
                    $('#message').find('#singleChatRightsideProf').css('display','block');
                  
                    $('#message').find('#singleChatRightsideProf').append('<div class="avatar-icon"><svg id="rightSideSvgprof" class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="height:50px;width:50px;"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg></div>');
                }

            }
            $('#message').find('.right-side-prof').html(Icon)
        }
        $('#message').find('.heading-name-meta').html(profilename);
        $("#message").css("display", "block");
        
        if (jid.indexOf('mix.') != -1) {

            let is_invitation_div = $("[id='conversation"+divJid+"']").find('.invitation_div')[0];
            $("[id='conversation"+divJid+"']").find('.invitation_div').remove();

            if ($("[id='conversation"+divJid+"']").length == 0 || typeof is_invitation_div != "undefined") {
                $('#conversation').append('<div class="row msglist message" id="conversation' + divJid + '"></div>');
                module.exports.getGroupChat(jid, scrollposition, messageId);
            } else {
                msgPageCount = 1;
                $(".msglist").hide();
                $('.loader').css("display", "none");
                $("[id='conversation"+divJid+"']").show();
                $("[id='conversation"+divJid+"']").find('.message-body[data-status]').each(function () {
                    let id = $(this).attr('id');
                    let msgid = id.split('-');
                    let from = $(this).attr('data-msgfrom');
                    let priority = $(this).attr('data-priority');
                    let ack = $(this).attr('data-ack');
                    if ($(this).attr('data-status') == 0) {
                        module.exports.sendDeliverStatus(from, msgid[1]);
                        setTimeout(function () {
                            module.exports.sendSeenStatus(from, msgid[1], priority, ack, divJid);
                        }, 2000);
                    } else if ($(this).attr('data-status') == 1) {
                        module.exports.sendSeenStatus(from, msgid[1], priority, ack, divJid);
                    }
                });
                utils.scrollbottom("[id='conversation"+divJid+"']");
            }

            module.exports.getGroupChatMedia(jid, '');
            load_page = 'group';

            if(groupInfo[divJid][4] === "2") {
                let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails')

                let userJID = stropheConnection.logininfo.userJID;
                let grpUsers = [];
                grpUsers = module.exports.updateuserprofGetGrpUser(grpUsers,groupDetail,userJid)
                let grpMem = module.exports.updateuserprofGetGrpMem(grpUsers,userJID)
                
                if(grpMem){
                    $(".row.reply.reply-box").show()
                    $(".row.reply.reply-box").css('display','flex')
                }
            }
        } else {
            let id = stropheConnection.Strophe().getNodeFromJid(jid);
            if (broadcastProfile != null && typeof broadcastProfile[id] != "undefined" && broadcastProfile[id][0] == 'broadcast') {
                if ($("[id='conversation"+divJid+"']").length == 0) {
                    $('#conversation').append('<div class="row msglist message" id="conversation' + divJid + '"></div>');
                    module.exports.getBroadcastChat(jid, scrollposition, messageId);
                } else {
                    msgPageCount = 1;
                    $(".msglist").hide();
                    $('.loader').css("display", "none");
                    $("[id='conversation"+divJid+"']").show();
                    utils.scrollbottom("[id='conversation"+divJid+"']");
                }

                module.exports.getBroadcastChatMedia(jid, '');
            $('.invitation_div').css('display','block!important')

            } else {
                let is_invitation_div = $("[id='conversation"+divJid+"']").find('.invitation_div')[0];
                $("[id='conversation"+divJid+"']").find('.invitation_div').remove();
                
                if ($("[id='conversation"+divJid+"']").length == 0 || typeof is_invitation_div != "undefined") {
                    $('#conversation').append('<div class="row msglist message" id="conversation' + divJid + '"></div>');
                    module.exports.getSingleChat(jid, scrollposition, messageId);
                } else {

                    msgPageCount = 1;
                    $(".msglist").hide();
                    $('.loader').css("display", "none");
                    $("[id='conversation"+divJid+"']").show();
                    utils.scrollbottom("[id='conversation"+divJid+"']");
                    $("[id='conversation"+divJid+"']").find('.message-body[data-status]').each(function () {
                        let id = $(this).attr('id');
                        let msgid = id.split('-');
                        let broadcastMsgId = $(this).attr('data-broadcastmsgid')
                        let priority = $(this).attr('data-priority');
                        let ack = $(this).attr('data-ack');
                        let from = stropheConnection.Strophe().getNodeFromJid(webEncrypt.getFromLocalStorageAndDecrypt('toJID'));
                        if ($(this).attr('data-status') == 0) {
                            module.exports.sendDeliverStatus(from, msgid[1]);
                            setTimeout(function () {
                                module.exports.sendSeenStatus(from, msgid[1], priority, ack, divJid,broadcastMsgId);
                            }, 2000);
                        } else if ($(this).attr('data-status') == 1) {
                            module.exports.sendSeenStatus(from, msgid[1], priority, ack, divJid,broadcastMsgId);
                        }
                    });

                }
                module.exports.getSingleChatMedia(jid, '');
            }
        }

        let priorityCount = webEncrypt.getFromLocalStorageAndDecrypt('usersPriorityInfo');
        if(priorityCount != null && typeof priorityCount[userJid] != "undefined") {
            let count = priorityCount[userJid][1];
            if(count == 1 && $( "[id='conversation"+userJid+"']").find(".priority-message-conversation").length == 0) {
                $("[id='conversation"+userJid+"']").prepend("<div class='priority-message-conversation'> PRIORITY: You have a Priority Message </div>");
            } else if (count > 1 && $("[id='conversation"+userJid+"']").find(".priority-message-conversation").length == 0) {
                $("[id='conversation"+userJid+"']").prepend("<div class='priority-message-conversation'> PRIORITY: You have <span class='priority-count'>" + count + "</span> Priority Messages </div>");
            }
        }


        if(isChatUser == 0){
            $('.invitation_div').css('display','block!important')
            profilename = $('.mCSB_container').children("[id='roster-"+userJid+"']").find('.contact-list').html()
            let email = $("[id='nonapp-"+userJid+"']").html();
            $(".block-con").hide();
            $(".unblock-con").show();
            $(".blocked-person").text("You cannot send messages to this chat.");
            
            if(userInfo != null && typeof userInfo[nodeJid] != "undefined"){
                let isUnregister = userInfo[nodeJid][16];

                if(isUnregister != 1){
                    $(".blocked-person").css("display", "none");

                }else {
                    $(".blocked-person").css("display", "block");
                }
            }

            $('.heading-attach').hide();
            $(".row.reply").css("display", "none");
            $(".contact-exit").css("display", "none");
            $(".contact-msg").css("display", "none");
            $(".contact-clearmsg").css("display", "none");
            $("#pager_right").css("display", "none");
            $("#replyemoji").hide();
            $("#microphone").hide();
            let iosInviteLink =  language.locali().IosInviteLink
            let andrioidInviteLink =  language.locali().andrioidInviteLink


            $(".msglist").html('<div class="invitation_div"><div class="invitation_class"><b style="font-size:13px;">Invitation to download Ikonix Connect</b></div><a  class="button_mail" href="mailto:'+email+'?subject=Invitation%20to%20use%20Ikonix%20Connect&body=Hi%20'+ profilename +'%2C%0A%0AIkonix%20Connect%20is%20a%20secure%20enterprise%20messaging%20app%20designed%20to%20connect%20people%20across%20our%20organisation.%0A%0ATo%20get%20started%2Cdownload%20it%20here%0A%0AiOS:%20'+encodeURIComponent(iosInviteLink)+'%0A%0AAndroid:'+encodeURIComponent(andrioidInviteLink)+'%0A%0A"><b>INVITE</b></a></div>')
        }
        else{

            $(".contact-exit").css("display", "block");
            $(".contact-msg").css("display", "block");
            $(".contact-clearmsg").css("display", "block");

            if(userInfo != null && typeof userInfo[nodeJid] != "undefined"){
               
                let isUnregister = isUnregisterUser;
                if(isUnregister == 1 && isChatUser != 1){
                    $(".blocked-person").css("display", "block");
                    $('#attachmentDiv').css('display','none')
                    $('#con-head .heading-dot').css('display','none')
                    $(".blocked-person").text("You cannot send messages to this chat.");
                    $('#blck-unblck-del .block-con').hide();
                    $('#blck-unblck-del .unblock-con').hide();

                }else {
                    $('.invitation_div').css('display','none')
                    if(!(blockUserInfo != null && typeof blockUserInfo[userJid] != "undefined")){
                        $(".blocked-person").css("display", "none");
                        $(".row.reply").css("display", "block");
                        $('.row.reply').css('display', 'flex');
                    }
                    if(userInfo != null && typeof userInfo[nodeJid] != "undefined"){
                        if(userInfo[nodeJid][3] == '') { // Check User status is empty (alias chat)
                            $(".blocked-person").css("display", "block");
                            $(".row.reply").css("display", "none");
                        }
                    }else {
                        $(".row.reply").css("display", "block");
                        $('.row.reply').css('display', 'flex');
                        $('#attachmentDiv').css('display','block')
                        $('#con-head .heading-dot').css('display','block')
                        $(".contact-exit").css("display", "block");
                        $(".contact-msg").css("display", "block");
                        $(".contact-clearmsg").css("display", "block");
                        $("#pager_right").css("display", "block");
                        $("#replyemoji").show();
                        $("#microphone").show();
                    }
                   
                }
            }
            
        }
    } catch (error) {
        console.log("Message Layout Error : ", error)    
    }
    },
    memberreorder: function () {
        let $divs = $("div.groupmembers");
        let alphabeticallyOrderedDivs = $divs.sort(function (a, b) {
            return $(a).find(".contactname").text() > $(b).find(".contactname").text() ? 1 : -1;
        });
        $("#groupmemberslist").html(alphabeticallyOrderedDivs);
    },
    updateuserprofileFillColor: function(groupInfo,id){
        let fillColor = groupInfo[id][8]?utils.hexToRgbA(groupInfo[id][8]):"#fff";
        return fillColor;
    },
    getSortedMemberInAscOrder:function(data){ // Group member In Asc Order
        // Convert the object to an array of [key, value] pairs
        let dataArray = Object.entries(data);

        // Custom sorting function
        const customSort = (a, b) => {
            const nickNameA = a[1].nickName.trim();
            const nickNameB = b[1].nickName.trim();

            // Function to get the sorting priority
            const getPriority = (char) => {
                if (char >= '0' && char <= '9') return 0; // numbers first
                if (char.toLowerCase() >= 'a' && char.toLowerCase() <= 'z') return 1; // letters next
                return 2; // other characters last (though we don't expect them here)
            };

            // Get the first character of nicknames for priority
            const firstCharA = nickNameA.charAt(0);
            const firstCharB = nickNameB.charAt(0);

            // Compare based on priority first
            const priorityA = getPriority(firstCharA);
            const priorityB = getPriority(firstCharB);

            if (priorityA !== priorityB) {
                return priorityA - priorityB;
            }

            // If priority is the same, compare lexically without case sensitivity
            return nickNameA.toLowerCase().localeCompare(nickNameB.toLowerCase());
        };

        // Sort the array by the custom sorting function
        dataArray.sort(customSort);

        // Create a new object with keys in ascending order (0, 1, 2, ...)
        let sortedData = {};
        dataArray.forEach((item, index) => {
            sortedData[index + 1] = item[1]; // maintain 1-based index keys
        });

        return sortedData;
    },
    getUserProfListImage: function(image,mediaUrl,userToken){
        if (image !== 'src/images/avatar/chat/profile_img_one.svg' && image.trim() !== '') {
            image = mediaUrl + image + "?mf=" + userToken;
        } else if (image.trim() == '') {
            image = "src/images/avatar/chat/profile_img_one.svg";
        }

        return image;
    },
    updateuserprofUserList: function(groupmember,mediaUrl,userToken,tojid){
        let status,image,userlist="",usersplit='',len=0,displayName,participantDiv,imageDiv,nameDiv,statusDiv,nickNameJID;
        let userJID = stropheConnection.logininfo.userJID;
        $(".delete-broadcast-link").attr('toJid',tojid)
        for (let key in groupmember) {
            let value = groupmember[key];

            if (value.user != userJID && value.user != '') {
                displayName = value.nickName;
                image = value.image;
                status = value.status;
                nickNameJID = stropheConnection.Strophe().getNodeFromJid(displayName);

                image = module.exports.getUserProfListImage(image,mediaUrl,userToken);

                let concatedLetter;
                if(displayName != "") {
                    concatedLetter = utils.getImageDisplayText(displayName);
                }

                if(image == "src/images/avatar/chat/profile_img_one.svg"){
                    imageDiv = '<div class="avatar-icon groupparticipantcontent"><svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg><img class="contact-image fave_icone" src="./src/images/svg/ikonixicon.svg"></div></div>';

                }else {
                    imageDiv = '<div class="avatar-icon groupparticipantcontent avatar-icon-height"><img id="broadcastParticipantcontent-'+nickNameJID+'" src="' + image + '"><img class="contact-image fave_icone" src="./src/images/svg/ikonixicon.svg"></div> </div>';
                }

                participantDiv = '<div class="row sideBar-body sideParticipant"  id="member-' + value.user + '"><div class="col-sm-3 col-xs-3 sideBar-avatar">';

                let dropdowntext = '<div class="dropdown contact-opt groupmember"><a class="dropdown-toggle" id="menu1" type="button" data-toggle="dropdown"><i class="option-arrow"></i></a><ul class="dropdown-menu contact-menu" role="menu" aria-labelledby="menu1"><li role="presentation"><a class="remove-broadcast-cnt-link">Remove</a></li></ul></div>';

                nameDiv = '<div class="col-sm-9 col-xs-9 sideBar-main"><div class="row user-name"><div class="col-sm-12 col-xs-12 sideBar-name"><span class="broadcastNameMeta name-meta">' + minEmoji(displayName) + '</span>';
                statusDiv = '<div class="sideBar-msg"><span class="name-status" style="color:'+utils.getStatusImage(status)+'">' + minEmoji(utils.getStatusName(status)) + ' </span>'+dropdowntext+'</div></div></div></div></div>';
                $("#groupparticipant").append(participantDiv + imageDiv + nameDiv + statusDiv);

                userlist = userlist + usersplit + displayName;
                usersplit = ", ";
                len ++;
            }
            module.exports.broadcastMemberClick();
        }

        return userlist;
    },
    updateuserprofUserInfoDesign: function(userInfo,id,infoLine){
        if(userInfo[id][7] != '1'){
            if(infoLine != ''){
                $('.heading-info').show();
                $('.heading-info .infoLine').html(infoLine)
            }
        }else {
            $('.heading-info').hide();
        }
    },
    updateuserprofUserInfoImage: function(image,userInfo,id,mediaUrl,userToken){
        if(typeof image === 'undefined'){
            image = "src/images/avatar/chat/profile_img_one.svg";
        }else {
            let unregisteredUser = userInfo[id][16];
            if (unregisteredUser != 1) {

                if (image != null && image !== 'src/images/avatar/chat/profile_img_one.svg' && image.trim() !== '') {
                    image = mediaUrl + image + "?mf=" + userToken;
                } else if (image.trim() == '') {
                    image = "src/images/avatar/chat/profile_img_one.svg";
                }
            } else {
                image = "src/images/avatar/chat/profile_img_one.svg";
            }
        }

        return image;
    },
    updateuserprofUserProfile: function(id,userInfo){
        if(id != storage.adminName() && userInfo[id][7] != "1") {
            userprofile.getUserProfile(id);
        }
    },

    updateuserprofBlockUserHandle: function(blockUserInfo,id,userInfo,name){
        
        if (blockUserInfo != null && typeof blockUserInfo[id] != "undefined") {
            $(".block-con").hide();
            $(".unblock-con").show();
            $(".blocked-person").text("Can't send a message to blocked contact " + minEmoji(name));
            $('.heading-attach').hide();
            $("#pager_right").css("display", "none");
            $(".row.reply").css("display", "none");
            $(".blocked-person").css("display", "block");
            $("#replyemoji").hide();
            $("#microphone").hide();

        } else {
            if(typeof userInfo[id][16] == 'undefined' || userInfo[id][16] == 1){
                $(".block-con").hide();
                $(".unblock-con").hide();
            }else {
                $(".block-con").show();
                $(".unblock-con").hide();
            }
            if (id == storage.adminName() || userInfo[id][7] == "1") {
                $('.reply-recording').hide();
                $('.heading-attach').hide();
                $("#pager_right").css("display", "none");
                $("#message .heading-dot").hide();
                $(".blocked-person").text(language.locali().get_alias_conv_content);
                $(".blocked-person").css("display", "block");
                $(".row.reply").css("display", "none");
                $('.emojiPickerIconWrap').hide();

            } 
        }
    },
    updateuserprofGetGrpOwner: function(grpOwner,groupDetail,id){
        
        if (groupDetail != null && typeof groupDetail[id] != "undefined") {
            let groupmember = groupDetail[id];
            for (let keys in groupmember) {
                let values = groupmember[keys];
                if (values.type == "o") {
                    grpOwner.push(values.user);
                } else {
                    grpOwner.push("");
                }
            }
        }

        return grpOwner;
    },
    updateuserproCallAddParticipant: function(){
        
        $("body").on('click', '.add-participant-link', function (e) {
            e.stopImmediatePropagation();
            $('.add-participant-msg-send').attr('data-isBroadcast',0)
            $('.add-participant-msg-send').attr('data-isgroup',1)
            webEncrypt.deleteItemFromLocalStorage('selecteduserInfo');

            $('.globalSiteExistTeam').removeClass('active');
            $('.mySiteExistTeam').addClass('active');
            $("#add-participant").css("display", "block");
            $("#add-participant").addClass("open");
            $('#partticipantText').attr("placeholder", "Search contacts");
            
            module.exports.triggerGlobalParticipantContacts()
            
        });
    },
    triggerGlobalParticipantContacts: function(){
        $('.mySiteExistTeam').removeClass('active');
        
        $("#partticipantText").val('');
        let globalSiteQueryParams;
        let search = $("#partticipantText").val();
        if (search == ""){
          globalSiteQueryParams = '?size=' + language.locali().default_size_pagination + '&isChatUser=1&page=1';
        } else {
          globalSiteQueryParams = '?size=' + language.locali().default_size_pagination + '&isChatUser=1&page=1&search=' + search;
        }
        
          contact.getExistingGroupContacts(globalSiteQueryParams);
      
          $("#participantcontact").scrollTop(0)
    },
    updateuserprofGetGrpUser: function(grpUsers,groupDetail,id){
        let groupmember;
        
        if (groupDetail != null && typeof groupDetail[id] != "undefined") {
            groupmember = groupDetail[id];
            for (let keys in groupmember) {
                let values = groupmember[keys];
                let itemvalue = values.user;
                $("#participantcontact").find("[id='forwardcontact-"+itemvalue+"']" ).css('display', 'none');
                grpUsers.push(values.user);
            }
        }
        return grpUsers;
    },
    updateuserprofGetGrpMem: function(grpUsers,userJID){
        let grpMem;
        if ($.inArray(userJID.toLowerCase(), grpUsers) != -1) {
            grpMem = true;
        } else {
            grpMem = false;
        }

        return grpMem;
    },
    updateuserprofGetImgDiv: function(ProfileImage,Icon,mediaUrl,userToken,id){
        
        let imgDiv;
        if(utils.getHexRegexPattern().test(ProfileImage)) {
            $('#message').find('.right-side-prof').html(Icon)
            $('#message .heading-avatar-icon div').first().attr('src','')
            let colorCode = utils.hexToRgbA(ProfileImage);
            imgDiv = '<div class="color-code-group-info user_profile-image icons" style="display: block; background-color: ' + colorCode + ';">'+Icon+'</div>';
        } else if (ProfileImage !== 'src/images/avatar/group/group_four.svg' && ProfileImage.trim() !== '') {
            indexDb.blobImageConversion(mediaUrl + ProfileImage + "?mf=" + userToken,'#userInfoGroupImg-'+id+'',id,'profileImages');
            imgDiv = '<img id="userInfoGroupImg-'+id+'" class="user_profile-image" src=' + mediaUrl + ProfileImage + "?mf=" + userToken + '></img>';
        } else {
            imgDiv = '<img class="user_profile-image" src="src/images/avatar/group/group_four.svg"></img>';
        }
        return imgDiv;
    },
    updateuserprofGetViewGrp: function(ProfileImage){
        let viewgroup;
        if (ProfileImage != "src/images/avatar/group/group_four.svg") {
            viewgroup = '<li role="presentation"><a id="view-grppro-pic" href="javascript:void(0)">View Profile</a></li>';
        } else {
            viewgroup = '';
        }

        return viewgroup;
    },
    updateuserprofGetGrpMemEmpty: function(userJID, grpOwner){
        if ($.inArray(userJID, grpOwner) != -1) {
            $('.add-participant-link').css('display', 'block');
            $('.add-participant-link').css('height', 'auto !important');

        } else {
            $(".groupadmin").html('');
            $(".groupmember").html('');
        }
    },
    updateUserProGetImage: function(imageId,mediaUrl,userToken){
        let image;
        if (imageId !== 'src/images/avatar/group/group_four.svg' && imageId.trim() !== '') {
            image = mediaUrl + imageId + "?mf=" + userToken;
            if (image.trim() == '' || image === undefined) {
                image = imageId;
            }else {
                indexDb.blobImageConversion(image,'.prof-big img',imageId,'profileImages');
            }
        } else if (imageId == '') {
            image = 'src/images/avatar/group/group_four.svg';
        } else {
            image = imageId;
        }

        return image;
    },
    updateuserprofViewGrpCall: function(){
        let image;
        
        $("#view-grppro-pic").click(function () {
            let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID');

            if (toJID != null && typeof toJID != "undefined") {
                let id = stropheConnection.Strophe().getNodeFromJid(toJID);
                let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
                let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
                let username = loginUserInfo[0][0];
                storage.setSession(username)
                let userToken = storage.getuserToken();
                let imageId;
                if (groupInfo != null && typeof groupInfo[id] != "undefined" && groupInfo[id][0] == 'group') {
                    imageId = groupInfo[id][2];
                    image = module.exports.updateUserProGetImage(imageId,mediaUrl,userToken)
                    
                    $('.popup').find('.popup-head').find('img').css('display', 'block');
                    $('.popup').find('.prof-big').find('img').css('display', 'block');
                    $('.popup').find('.popup-head').find('video').css('display', 'none');
                    $('.popup').find('.prof-big').find('video').css('display', 'none');
                    $('.popup').find('.popup-head').find('img').attr('src', image);
                    $('.content').find('.prof-big').find('img').attr('src', image);
                    $('#popup-full').css('visibility', 'visible');
                    $('#popup-full').css('opacity', '1');
                    $('.popup').find('.prof-big').find('#audiocontent').css('display', 'none');
                }
            }

        });
    },
    updateuserprofUploadTrigger: function(groupDetail,id,mediaUrl,userToken){
        
        if (groupDetail != null && typeof groupDetail[id] != "undefined") {
            trigger.groupProfileUpload();
        } else {
            $('#comment').prop('disabled', true);
            $('.exit-chat').css('display', 'none');
            $('.reply-recording').hide();
            $('.emojiPickerIconWrap').hide();
            $('.exit-group-link').hide();
            $('.delete-group-link').show();
            $('.exit_group_text').text(language.locali().delete_group);
            $('.heading-attach').hide();
            $("#pager_right").css("display", "none");
            $(".groupadmin").html('');
            $(".groupmember").html('');
            $('.contact-exit').find('a').html('');
            $(".add-participant-link").hide();
            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')

            let ProfileImage = groupInfo[id][2];
            let imgDiv = "";
            if(utils.getHexRegexPattern().test(ProfileImage)) {
                let colorCode = utils.hexToRgbA(ProfileImage);
                imgDiv = '<div class="color-code-group-info user_profile-image" style="display: block; background-color: ' + colorCode + ';"></div>';
            } else if (ProfileImage !== 'src/images/avatar/group/group_four.svg' && ProfileImage.trim() !== '') {
                indexDb.blobImageConversion(mediaUrl + ProfileImage + "?mf=" + userToken,'#userProfileInfoImg-'+id+'',id,'profileImages');
                imgDiv = '<img id="userProfileInfoImg-'+id+'" class="user_profile-image" src=' + mediaUrl + ProfileImage + "?mf=" + userToken + '></img>';
            } else {
                imgDiv = '<img class="user_profile-image" src="src/images/avatar/group/group_four.svg"></img>';
            }

            $('#userprofile').find('.profile-inner').html(imgDiv + '<div class = groupname>' + minEmoji(groupInfo[id][1]) + '</div>');
            $('.heading-online').css('display', 'block');
            $('#groupparticipant').find('small').html(language.locali().participants + " <i>" + id + "</i>");
            $(".recentchatcontact").find("[id='forwardcontact-"+id+"']").remove();

        }
    },
    updateuserprofGrpEmojiDesign: function(){
        if ($('#groupupdateemoji').css('display') == 'block') {
            $("#groupupdateemoji").find(".wrap").find('em').unbind('click');
            $("#groupupdateemoji").hide();
        }
    },
    updateuserprofGrpEmojiClickFun: function(){
        
        $(".groupupdateemoji").click(function (e) {
            e.stopPropagation();
            let inputname = "groupupdate-name";
            $('#groupupdateemoji').html('');
            $('#groupupdateemoji').append($('#messageemoji').html());
            $("#messageemoji").hide();
            $("#profileemoji").hide();
            $("#statusemoji").hide();
            $("#groupemoji").hide();
            if ($('#groupupdateemoji').css('display') == 'block') {
                $("#groupupdateemoji").find(".wrap").find('em').unbind('click');
                $("#groupupdateemoji").hide();
            } else {
                $("#groupupdateemoji").show();
                utils.updateemojiclick(inputname);
            }
        });
    },
    updateuserprofGrpMemberAppend: function(grpMem,nodeJid,groupInfo,id,mediaUrl,userToken){
        let ProfileImage;

        if (!grpMem) {
            $("[id='"+nodeJid+"']").find(".priority-message-recent").remove();
            $("[id='conversation"+nodeJid+"']").find(".priority-message-conversation").css("display", "none");

            $(".recentchatcontact").find("[id='forwardcontact-"+nodeJid+"']").remove();
            $("[id='"+nodeJid+"']").find(".exitclass").remove();
            $(".acknowledge-icon").hide();

            $('#comment').empty();
            $('.exit-chat').css('display', 'none');
            $('.reply-recording').hide();
            $('.emojiPickerIconWrap').hide();
            $('.exit-group-link').hide();
            $('.delete-group-link').show();
            $('.heading-attach').hide();
            $("#pager_right").css("display", "none");
            $('.exit_group_text').text(language.locali().delete_group);
            $(".groupadmin").html('');
            $(".groupmember").html('');
            $('.contact-exit').find('a').html('');
            $(".add-participant-link").hide();
            $(".row.reply").css("display", "none");
            $(".blocked-person").css("display", "block");
            $(".blocked-person").text(language.locali().group_exit);
            ProfileImage = groupInfo[id][2];
            let imgDiv = "";
            if(utils.getHexRegexPattern().test(ProfileImage)) {
                let colorCode = utils.hexToRgbA(ProfileImage);
                imgDiv = '<div class="color-code-group-info user_profile-image" style="display: block; background-color: ' + colorCode + ';"></div>';
            } else if (ProfileImage !== 'src/images/avatar/group/group_four.svg' && ProfileImage.trim() !== '') {
                imgDiv = '<img id="groupmemuserInfo-'+id+'" class="user_profile-image" src=' + mediaUrl + ProfileImage + "?mf=" + userToken + '></img>';
                indexDb.blobImageConversion(mediaUrl + ProfileImage + "?mf=" + userToken,'#groupmemuserInfo-'+id+'',id,'profileImages');
            } else if (ProfileImage == '') {
                imgDiv = '<img class="user_profile-image" src="src/images/avatar/group/group_four.svg"></img>';
            }

            $('#userprofile').find('.profile-inner').html(imgDiv + '<div class = groupname>' + minEmoji(groupInfo[id][1]) + '</div>');
            $('.heading-online').css('display', 'block');
            $(".recentchatcontact").find("[id='forwardcontact-"+nodeJid+"']").remove();
        } 
    },
    updateuserprofGrpMemberDesign: function(groupInfo,id){
        if(typeof(groupInfo[id][4]) != "undefined" && groupInfo[id][4]) {
            $(".add-participant-link").hide();
            $(".groupadmin").html('');
            $(".groupmember").html('');
            $(".grp-admin").html('');
            $('.exit-group-link').hide();
            $("#userprofile .profile-content .profile-inner").find('ul').remove();
            $("#userprofile .profile-content .profile-inner").find("a.dropdown-toggle").removeClass("pic-opt");
            $(".groupNameEdit").css("display", "none");
        }
    },
    updateuserprofGrpNameEdit: function(){
        
        $(".groupNameEdit").click(function () {
            $('.groupname').css('display', 'none');
            $('.get-group-name').css('display', 'block');
            let text_max = 25;
            let text_length = $('.group-name').val().length;
            let text_remaining = text_max - text_length;
            $('.char-counter').html(text_remaining);
            $('#groupupdate-name').on('input', function () {
                text_length = $('#groupupdate-name').val().length;
                if (text_length <= 25) {
                    text_remaining = text_max - text_length;
                    $('.char-counter').html(text_remaining);
                } else {
                    let limitValue = $('#groupupdate-name').val().substring(0, 25);
                    $('#groupupdate-name').val(limitValue);
                }
            });
        });
    },
    updateuserprofGnUpClickEvent: function(){
        
        $(".gn-up").click(function () {
            $('input[type="text"].group-name').each(function () {
               let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
               let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);
               let GroupId =  nodeJid.split('@')[0];

                if ($(this).val().trim() != "") {
                    let grpName = $(this).val();
                    setTimeout(function(){  
                            $('#message').find('.heading-name-meta').html(minEmoji(grpName));
                     }, 500);

                    let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')

                    groupProfile.setGroupInfo($(this).val(), groupInfo[GroupId][2]);

                    $('#message').find('.heading-name-meta').html(minEmoji($(this).val()));
                    $("[id='"+nodeJid+"']").find('.name-meta').html($(this).val());
                    $('.get-group-name').css('display', 'none');
                    $('.groupname').css('display', 'block');
                    $('.groupname').html(minEmoji($(this).val()) + '<i class="groupNameEdit"><svg xmlns="http://www.w3.org/2000/svg" width="13.787" height="13.787" viewBox="0 0 13.787 13.787"> <path id="Edit_2_" data-name="Edit (2)" d="M10.7,140.726l1.4-1.4L10.268,137.5l-1.4,1.4v.675h1.157v1.157Zm5.3-8.677a.249.249,0,0,0-.4.012l-4.218,4.218a.273.273,0,1,0,.386.386l4.218-4.218A.249.249,0,0,0,16,132.049Zm-.193-1.735,3.471,3.471-8.1,8.1H7.713v-3.471Zm5.351,1.591-1.109,1.109-3.471-3.471,1.109-1.109a1.164,1.164,0,0,1,1.639,0l1.832,1.832a1.164,1.164,0,0,1,0,1.639Z" transform="translate(-7.713 -128.096)" fill="#9a9a9a"></path> </svg></i>');
                    $(".groupNameEdit").click(function () {
                        $('.groupname').css('display', 'none');
                        $('.get-group-name').css('display', 'block');
                        let text_max = 25;
                        let text_length = $('.group-name').val().length;
                        let text_remaining = text_max - text_length;
                        $('.char-counter').html(text_remaining);
                        $('.group-name').keyup(function () {
                            text_length = $('.group-name').val().length;
                            if (text_length <= 25) {
                                text_remaining = text_max - text_length;
                                $('.char-counter').html(text_remaining);
                            } else {
                                let limitValue = $('.group-name').val().substring(0, 25);
                                $('.group-name').val(limitValue);
                            }
                        });
                    });
                } else {
                    $("#infoContent").text(language.locali().entergroup_name);
                    $('#infobox').css("display", "block").delay(4000).fadeOut();
                }
            });
        });
    },
    broadCastExistAddParticipantTrigger: function(){
        $("body").on('click', '.add-broadcast-participant-link', function (e) {
            e.stopImmediatePropagation();
            $('.add-participant-msg-send').attr('data-isBroadcast',1)
            $('.add-participant-msg-send').attr('data-isgroup',0)
            webEncrypt.deleteItemFromLocalStorage('selecteduserInfo');

            $('.globalSiteExistTeam').removeClass('active');
            $('.mySiteExistTeam').addClass('active');
            $("#add-participant").css("display", "block");
            $("#add-participant").addClass("open");
            $('#partticipantText').attr("placeholder", "Search contacts");

            module.exports.triggerGlobalParticipantContacts()
            
        });


        $(".broadcastNameEdit").click(function () {
            let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
            let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);
            let broadCastInfo = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

            if(broadCastInfo != null && broadCastInfo[nodeJid]){
                $('#broadcast-update-name').val(broadCastInfo[nodeJid][1])
            }
            $('.groupname').css('display', 'none');

            $('.get-group-name').css('display', 'block');
            let text_max = 25;
            let text_length = $('.group-name').val().length;
            let text_remaining = text_max - text_length;
            $('.char-counter').html(text_remaining);
            
            $('#broadcast-update-name').on('input', function () {
                text_length = $('#broadcast-update-name').val().length;
                if (text_length <= 25) {
                    text_remaining = text_max - text_length;
                    $('.char-counter').html(text_remaining);
                } else {
                    let limitValue = $('#broadcast-update-name').val().substring(0, 25);
                    $('#broadcast-update-name').val(limitValue);
                }
            });
        });

        $(".br-up").click(function () {
            $('input[type="text"].group-name').each(function () {
               let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
               let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);

                if ($(this).val().trim() != "") {
                    let broadcastName = $(this).val();
                    setTimeout(function(){  
                            $('#message').find('.heading-name-meta').html(minEmoji(broadcastName));
                     }, 500);


                    broadcastProfileJs.setBroadcastInfo($(this).val());

                    $('#message').find('.heading-name-meta').html(minEmoji($(this).val()));
                    $("[id='"+nodeJid+"']").find('.name-meta').html($(this).val());
                    $('.get-broadcast-name').css('display', 'none');
                    $('.groupname').css('display', 'block');
                    $('.groupname').html(minEmoji($(this).val()) + '<i class="broadcastNameEdit"><svg xmlns="http://www.w3.org/2000/svg" width="13.787" height="13.787" viewBox="0 0 13.787 13.787"> <path id="Edit_2_" data-name="Edit (2)" d="M10.7,140.726l1.4-1.4L10.268,137.5l-1.4,1.4v.675h1.157v1.157Zm5.3-8.677a.249.249,0,0,0-.4.012l-4.218,4.218a.273.273,0,1,0,.386.386l4.218-4.218A.249.249,0,0,0,16,132.049Zm-.193-1.735,3.471,3.471-8.1,8.1H7.713v-3.471Zm5.351,1.591-1.109,1.109-3.471-3.471,1.109-1.109a1.164,1.164,0,0,1,1.639,0l1.832,1.832a1.164,1.164,0,0,1,0,1.639Z" transform="translate(-7.713 -128.096)" fill="#9a9a9a"></path> </svg></i>');
                    $(".broadcastNameEdit").click(function () {
                        $('.groupname').css('display', 'none');
                        $('.get-broadcast-name').css('display', 'block');
                        let text_max = 25;
                        let text_length = $('.group-name').val().length;
                        let text_remaining = text_max - text_length;
                        $('.char-counter').html(text_remaining);
                        $('.group-name').keyup(function () {
                            text_length = $('.group-name').val().length;
                            if (text_length <= 25) {
                                text_remaining = text_max - text_length;
                                $('.char-counter').html(text_remaining);
                            } else {
                                let limitValue = $('.group-name').val().substring(0, 25);
                                $('.group-name').val(limitValue);
                            }
                        });
                    });
                } else {
                    $("#infoContent").text(language.locali().entergroup_name);
                    $('#infobox').css("display", "block").delay(4000).fadeOut();
                }
            });
        });
        
    },
    checkBroadcastUserExistOrNot: function(groupmember,len){
        if(len == 0){
            $(".row.reply.reply-box").hide()
            $(".noUserAvilableInBroadcast").css('display','block')
        }else {
            if(len == 1){
                if(groupmember[0].user == ''){
                    len = 0;
                    $(".row.reply.reply-box").hide()
                    $(".noUserAvilableInBroadcast").css('display','block')
                }else {
                    $("noUserAvilableInBroadcast").hide();
                    $(".row.reply.reply-box").show()
                    $(".row.reply.reply-box").css('display','flex')
                }
            }else {
                $("noUserAvilableInBroadcast").hide();
                $(".row.reply.reply-box").show()
                $(".row.reply.reply-box").css('display','flex')
            }
           
        }
        return len;
    },
    updateuserprofile: function (id) {
        
        let mediaUrl = window._env_.ApiURL + "/media/";
        let userJID = stropheConnection.logininfo.userJID;
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let userToken = storage.getuserToken();
        let blockUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('blockUserInfo');

        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

        let broadcastDetails = webEncrypt.getFromLocalStorageAndDecrypt('broadcastDetails');

        let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
        let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);
        
        $('.groupNameEdit').css('display', 'none');
        $('.heading-info').css('display', 'none');
        let Icon ='';
        let name,image,elementId,userlist,len,groupmember,ParticipantLink,groupDetail,grpOwner,ProfileImage,viewgroup;
        if(groupInfo && typeof groupInfo[id] != "undefined"){
            let onCallIcon = groupInfo[id][7];
            let fillColor = module.exports.updateuserprofileFillColor(groupInfo,id);
            let iconBgcolor = groupInfo[id][2];
            Icon = this.getIcon(onCallIcon,iconBgcolor,fillColor);
        }
        if (broadcastProfile != null && typeof broadcastProfile[id] != "undefined" && broadcastProfile[id][0] == 'broadcast') {
            $('#userprofile').find('.user-contact').html('');
            $('.infocontent').html('Broadcast info');
            $('#groupparticipant').css('display', 'block');
            $('#userprofile').find('.user-contact').css('display', 'none');
            $('.contact-info').find('a').html(language.locali().broadcast_info);
            $('.contact-info').find('a').attr('title', language.locali().broadcast_info);
            $('.contact-exit').find('a').html(language.locali().delete_chat);
            $('.contact-exit').find('a').attr('title', language.locali().delete_chat);
            $('#userprofile').find('.profile-inner').html('<div class="prof-opt">  <img class="user_profile-image" src="src/images/avatar/broadcast/profile_img_one.png"></div><span class = groupname>' + minEmoji(broadcastProfile[id][1]) + '</span></div>');
            $('.groupNameEdit').css('display', 'block');

            $('#userprofile-popup').find('img').attr('src', "");
            $('#blck-unblck-del').css('display', 'none');
            $('.add-participant-link').css('display', 'none');
            $('.exit-chat').css('display', 'none');
            $('.get-group-name').css('display', 'none');
            $("#groupparticipant").html('');
            let broadcastName = broadcastProfile[id][1];

            $('.groupname').html(minEmoji(broadcastName) + '<i class="broadcastNameEdit"><svg xmlns="http://www.w3.org/2000/svg" width="13.787" height="13.787" viewBox="0 0 13.787 13.787"> <path id="Edit_2_" data-name="Edit (2)" d="M10.7,140.726l1.4-1.4L10.268,137.5l-1.4,1.4v.675h1.157v1.157Zm5.3-8.677a.249.249,0,0,0-.4.012l-4.218,4.218a.273.273,0,1,0,.386.386l4.218-4.218A.249.249,0,0,0,16,132.049Zm-.193-1.735,3.471,3.471-8.1,8.1H7.713v-3.471Zm5.351,1.591-1.109,1.109-3.471-3.471,1.109-1.109a1.164,1.164,0,0,1,1.639,0l1.832,1.832a1.164,1.164,0,0,1,0,1.639Z" transform="translate(-7.713 -128.096)" fill="#9a9a9a"></path> </svg></i>');

            let grpEmojiEl = '<div id="groupupdateemoji" style="display: none;"></div>';
            let grpEditEl = '<span class="get-group-name" style="display: none;"><div class="emojiPickerIconWrap"><input type="text" id="broadcast-update-name" maxlength="25" class="group-name"><div class="reg-group-name"><span class="char-counter">15</span><div class="emojiPickerIcon black groupupdateemoji" style="height: 32px; width: 32px; background-color: transparent;"></div></div><i class="br-up"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 30 30"> <g id="Tick_icon" data-name="Tick icon" transform="translate(-10856 17056)"> <rect id="Rectangle_16501" data-name="Rectangle 16501" width="20" height="20" transform="translate(10856 -17056)" fill="none"></rect> <path id="Path_149878" data-name="Path 149878" d="M101.546,57.688,99.3,55.445a1.625,1.625,0,0,0-2.324,0L83.791,68.634,78.43,63.273a1.625,1.625,0,0,0-2.324,0l-2.242,2.242a1.624,1.624,0,0,0,0,2.324L82.629,76.6a1.625,1.625,0,0,0,2.324,0l16.593-16.593a1.624,1.624,0,0,0,0-2.324Z" transform="translate(10783.295 -17107.023)" fill="#ee7020"></path> </g> </svg></i></div></span>';

            $('#userprofile .profile-inner').append(grpEmojiEl);
            $('#userprofile .profile-inner').append(grpEditEl);
            $('.delete-broadcast-link').show();
            $("#broadcast-update-name").val(minEmoji(broadcastName));
            $('.exit_broadcast_text').text(language.locali().delete_broadcast);

            let broadcastId = id;
            groupmember = broadcastDetails[id];
            len = Object.keys(groupmember).length;
            len = module.exports.checkBroadcastUserExistOrNot(groupmember,len);// Check Broadcast Exist or Not and Get Length of Broadcast User Details

            userlist = module.exports.updateuserprofUserList(groupmember,mediaUrl,userToken,tojid);
            let addParticipantLink = '<div class="row sideBar-body add-broadcast-participant-link" data-broadcast-id="'+broadcastId+'" data-broadcast-name="'+broadcastName+'" style="display: block;"><div class="add-people-icon"><i class="add-people"></i></div><div class="col-sm-9 col-xs-9 sideBar-main"><div class="row user-name"> <div class="col-sm-12 col-xs-12 name-meta add-name "><a class="">Add Participants</a></div></div></div></div>'
          
            ParticipantLink = '<div class="row compose-sideBar"><small>Recipients <i>' + len + '</i></small>'+addParticipantLink+'</div>'
            $("#groupparticipant").prepend(ParticipantLink);
            if(nodeJid == broadcastId){
                $('.heading-online').html(userlist);
            }
            $('.heading-online').css('display', 'block');
            $('#message .heading-avatar-icon img').attr('src','src/images/avatar/broadcast/profile_img_one.png')
            $(".singleuser").click(function () {
                let id = $(this).attr('id');
                let result = id.split(/-(.+)/);
                let toJID = result[1] + "@" + stropheConnection.Server();
                webEncrypt.encryptAndStoreInLocalStorage('toJID', toJID);
                lastActivity.lastActivity(toJID);
                module.exports.MessageLayout(toJID, 'down', '');
                $("#right-prof-back").trigger("click");
            });
            $("#pager_right").css("display", "none");
            module.exports.broadCastExistAddParticipantTrigger()

        } else if (userInfo != null && typeof userInfo[id] != "undefined" && userInfo[id][0] == 'chat') {
            $('.infocontent').html(language.locali().contact_info);
           
            $('.heading-online').css('display', 'block');
            $('#groupparticipant').css('display', 'none');
            $('#userprofile').find('.user-contact').css('display', 'block');
            $('.exit-group-link').show();
            $('.delete-group-link').hide();
            $('.delete-broadcast-link').hide();

            $('.exit_group_text').text(language.locali().exit_group);
            name = userInfo[id][1];
            image = userInfo[id][2];
            image = module.exports.updateuserprofUserInfoImage(image,userInfo,id,mediaUrl,userToken);
        
            $('#userprofile').find('.profile-inner').html('<img id="rightSideUserInfoImg-'+id+'" src="' + image + '" /><span class ="groupname">' + minEmoji(name) + '</span>');

            module.exports.updateuserprofUserProfile(id,userInfo)
           
            $('.contact-info').find('a').html(language.locali().contact_info);
            $('.contact-info').find('a').attr('title', language.locali().contact_info);
            $('.contact-exit').find('a').html(language.locali().delete_chat);
            $('.contact-exit').find('a').attr('title', language.locali().delete_chat);
            $('#userprofile-popup').find('img').attr('src', image);
            $('#blck-unblck-del').css('display', 'block');

            module.exports.updateuserprofBlockUserHandle(blockUserInfo,id,userInfo,name)
            $('.exit-chat').css('display', 'none');
        } else if (groupInfo != null && typeof groupInfo[id] != "undefined" && groupInfo[id][0] == 'group') {
            groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');

            grpOwner = [];
            $("#pager_right").css("display", "none");
            grpOwner = module.exports.updateuserprofGetGrpOwner(grpOwner,groupDetail,id)

            module.exports.updateuserproCallAddParticipant()
            

            let grpUsers = [];
            grpUsers = module.exports.updateuserprofGetGrpUser(grpUsers,groupDetail,id)
            let grpMem = module.exports.updateuserprofGetGrpMem(grpUsers,userJID)

            $('#userprofile').find('.user-contact').html('');
            $('.infocontent').html(language.locali().group_info);
            $('#groupparticipant').css('display', 'block');
            $('.groupNameEdit').css('display', 'block');
            $('.contact-info').find('a').html(language.locali().group_info);
            $('.contact-info').find('a').attr('title', language.locali().group_info);
            $('.contact-exit').find('a').html(language.locali().exit_group);
            $('.contact-exit').find('a').attr('title', language.locali().exit_group);
            elementId = "'input#group-image-upload'";
            ProfileImage = groupInfo[id][2];

            let imgDiv = "";
            imgDiv = module.exports.updateuserprofGetImgDiv(ProfileImage,Icon,mediaUrl,userToken,id)

            viewgroup = module.exports.updateuserprofGetViewGrp(ProfileImage)
           
            $('#userprofile').find('.profile-inner').html('<div class="dropdown prof-opt"> <a class="pic-opt dropdown-toggle" type="button" data-toggle="dropdown">' + imgDiv + '</a><ul class="dropdown-menu head-option" role="menu3" aria-labelledby="menu3">' + viewgroup + '<li role="presentation"> <a href="javascript:document.querySelector(' + elementId + ').click()">' + language.locali().upload_photo + '</a> <input accept="image/*" type="file" name="group-image-upload" id="group-image-upload" style="display:none"> </li> <li role="presentation"><a id="group-pro-camera" href="javascript:void();">' + language.locali().take_photo + '</a></li> </ul> </div><div class = groupname>' + minEmoji(groupInfo[id][1]) + '<i class="groupNameEdit"><svg xmlns="http://www.w3.org/2000/svg" width="13.787" height="13.787" viewBox="0 0 13.787 13.787"> <path id="Edit_2_" data-name="Edit (2)" d="M10.7,140.726l1.4-1.4L10.268,137.5l-1.4,1.4v.675h1.157v1.157Zm5.3-8.677a.249.249,0,0,0-.4.012l-4.218,4.218a.273.273,0,1,0,.386.386l4.218-4.218A.249.249,0,0,0,16,132.049Zm-.193-1.735,3.471,3.471-8.1,8.1H7.713v-3.471Zm5.351,1.591-1.109,1.109-3.471-3.471,1.109-1.109a1.164,1.164,0,0,1,1.639,0l1.832,1.832a1.164,1.164,0,0,1,0,1.639Z" transform="translate(-7.713 -128.096)" fill="#9a9a9a"></path> </svg></i></div><div id="groupupdateemoji"></div><span class="get-group-name"><div class="emojiPickerIconWrap"><input type="text" id="groupupdate-name" maxlength="25" class="group-name"><div class="reg-group-name"><span class="char-counter"></span><div class="emojiPickerIcon black groupupdateemoji" style="height: 32px; width: 32px; background-color: transparent;"></div></div><i class="gn-up"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 30 30"> <g id="Tick_icon" data-name="Tick icon" transform="translate(-10856 17056)"> <rect id="Rectangle_16501" data-name="Rectangle 16501" width="20" height="20" transform="translate(10856 -17056)" fill="none"/> <path id="Path_149878" data-name="Path 149878" d="M101.546,57.688,99.3,55.445a1.625,1.625,0,0,0-2.324,0L83.791,68.634,78.43,63.273a1.625,1.625,0,0,0-2.324,0l-2.242,2.242a1.624,1.624,0,0,0,0,2.324L82.629,76.6a1.625,1.625,0,0,0,2.324,0l16.593-16.593a1.624,1.624,0,0,0,0-2.324Z" transform="translate(10783.295 -17107.023)" fill="#ee7020"/> </g> </svg></i></div></span>');

            $('#blck-unblck-del').css('display', 'none');
            $('.exit-chat').css('display', 'block');
            $('.get-group-name').css('display', 'none');
            $('.delete-group-link').hide();
            $('.delete-broadcast-link').hide();

            $('.exit_group_text').text(language.locali().exit_group);

            module.exports.updateuserprofGetGrpMemEmpty(userJID, grpOwner)
            
            $('.exit-group-link').show();
            $('.group-name').val(groupInfo[id][1]);

            module.exports.updateuserprofViewGrpCall()

            module.exports.updateuserprofUploadTrigger(groupDetail,id,mediaUrl,userToken)
            
            module.exports.updateuserprofGrpEmojiDesign()

            module.exports.updateuserprofGrpEmojiClickFun()

            module.exports.updateuserprofGrpMemberAppend(grpMem,nodeJid,groupInfo,id,mediaUrl,userToken)

            module.exports.updateuserprofGrpMemberDesign(groupInfo,id)

        }

        module.exports.updateuserprofGrpNameEdit()

        module.exports.updateuserprofGnUpClickEvent()
       
        $(".groupparticipantcontent").click(function () {
            id = $(this).closest('.sideBar-body').attr('id');
            let result = id.split(/-(.+)/);
            $("#conversation").empty();
            let toJID = result[1] + "@" + stropheConnection.Server();
            webEncrypt.encryptAndStoreInLocalStorage('toJID', toJID);

            lastActivity.lastActivity(toJID);
            module.exports.MessageLayout(toJID, 'down', '');
        });
        module.exports.groupmemberclick();
    },
    getIcon:function(onCallIcon,onCallImage,fillColor){
        let Icon;
        switch (onCallIcon) {
            case 'Ambulance':
                Icon = '<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26848" data-name="Group 26848" transform="translate(-9318 -11373)">\n' +
                    '    <g id="Group_26842" data-name="Group 26842">\n' +
                    '      <circle id="Ellipse_254" data-name="Ellipse 254" cx="75" cy="75" r="75" transform="translate(9318 11373)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '      <path id="ambulance" d="M49.471,177.472a4.948,4.948,0,1,1,1.449,3.5A4.767,4.767,0,0,1,49.471,177.472Zm14.841-19.789H49.471v-9.894h6.107a1.607,1.607,0,0,1,.85.348l7.537,7.537a2.823,2.823,0,0,1,.348.85ZM14.841,177.472a4.948,4.948,0,0,1,4.947-4.947,4.947,4.947,0,1,1-3.5,8.445A4.766,4.766,0,0,1,14.841,177.472ZM9.894,151.5v-7.421a1.191,1.191,0,0,1,1.237-1.237h8.657v-8.658a1.191,1.191,0,0,1,1.237-1.237h7.421a1.191,1.191,0,0,1,1.237,1.237v8.658H38.34a1.191,1.191,0,0,1,1.237,1.237V151.5a1.191,1.191,0,0,1-1.237,1.237H29.683v8.657a1.191,1.191,0,0,1-1.237,1.237H21.025a1.191,1.191,0,0,1-1.237-1.237v-8.657H11.131A1.191,1.191,0,0,1,9.894,151.5ZM0,130.474V175a2.377,2.377,0,0,0,.734,1.739,2.377,2.377,0,0,0,1.739.734H9.894a9.533,9.533,0,0,0,2.9,7,9.533,9.533,0,0,0,7,2.9,9.533,9.533,0,0,0,7-2.9,9.533,9.533,0,0,0,2.9-7H44.524a9.893,9.893,0,0,0,16.89,7,9.533,9.533,0,0,0,2.9-7H69.26a2.474,2.474,0,0,0,0-4.947V156.446a6.027,6.027,0,0,0-.5-2.242,5.876,5.876,0,0,0-1.237-1.971l-7.653-7.653a5.875,5.875,0,0,0-1.971-1.237,6.026,6.026,0,0,0-2.242-.5H49.471V130.474A2.508,2.508,0,0,0,47,128H2.474a2.377,2.377,0,0,0-1.739.734A2.377,2.377,0,0,0,0,130.474Z" transform="translate(9357 11290)"    fill="'+fillColor+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>'
                break;
            case "Group":
                Icon = '<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26856" data-name="Group 26856" transform="translate(-9312 -11567)">\n' +
                    '    <circle id="Ellipse_254" data-name="Ellipse 254" cx="75" cy="75" r="75" transform="translate(9312 11567)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="group_12_" data-name="group (12)" transform="translate(9343 11612.5)">\n' +
                    '      <circle id="Ellipse_260" data-name="Ellipse 260" cx="7.304" cy="7.304" r="7.304" transform="translate(7.304 11.978)"    fill="'+fillColor+'"/>\n' +
                    '      <path id="Path_20434" data-name="Path 20434" d="M24.357,14.461a15.3,15.3,0,0,0-6.1,12.234v.913H2.739A2.759,2.759,0,0,1,0,24.868V23.042A10.037,10.037,0,0,1,10.042,13h9.129A9.977,9.977,0,0,1,24.357,14.461Z" transform="translate(0 17.237)"    fill="'+fillColor+'"/>\n' +
                    '      <circle id="Ellipse_261" data-name="Ellipse 261" cx="7.304" cy="7.304" r="7.304" transform="translate(65.732 11.978)"     fill="'+fillColor+'"/>\n' +
                    '      <path id="Path_20435" data-name="Path 20435" d="M41.687,23.042v1.826a2.759,2.759,0,0,1-2.739,2.739H23.429v-.913a15.3,15.3,0,0,0-6.1-12.234A9.977,9.977,0,0,1,22.516,13h9.129A10.037,10.037,0,0,1,41.687,23.042Z" transform="translate(45.956 17.237)"  fill="'+fillColor+'"/>\n' +
                    '      <circle id="Ellipse_262" data-name="Ellipse 262" cx="10.279" cy="10.279" r="10.279" transform="translate(33.065 6.5)" fill="'+fillColor+'"/>\n' +
                    '      <path id="Path_20436" data-name="Path 20436" d="M36.627,14H16.542A10.051,10.051,0,0,0,6.5,24.042V29.52a2.74,2.74,0,0,0,2.739,2.739H43.931A2.74,2.74,0,0,0,46.67,29.52V24.042A10.051,10.051,0,0,0,36.627,14Z" transform="translate(17.237 19.888)" fill="'+fillColor+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Role':
                Icon =  '<svg class="svg-code-roles conv-roles" xmlns="http://www.w3.org/2000/svg" width="24px" height="51px" viewBox="0 0 12.195 10.085">\n' +
                    '  <g id="Group_27174" data-name="Group 27174" transform="translate(0.15 0.15)">\n' +
                    '    <g id="Id_Card" data-name="Id Card" transform="translate(0 0)">\n' +
                    '      <path id="Path_10935" data-name="Path 10935" d="M11.147,23.379H.747A.75.75,0,0,1,0,22.63V16.147A.747.747,0,0,1,.747,15.4H4.512a.18.18,0,0,1,0,.361H.747a.386.386,0,0,0-.387.387V22.63a.387.387,0,0,0,.387.387h10.4a.387.387,0,0,0,.387-.387V16.147a.386.386,0,0,0-.387-.387H7.564a.18.18,0,0,1,0-.361h3.583a.747.747,0,0,1,.747.747V22.63A.749.749,0,0,1,11.147,23.379Z" transform="translate(0 -13.594)" fill="'+fillColor+'" stroke="'+fillColor+'" stroke-width="0.3"/>\n' +
                    '      <path id="Path_10937" data-name="Path 10937" d="M9.127,26.377a1.084,1.084,0,1,1,1.084-1.084A1.085,1.085,0,0,1,9.127,26.377Zm0-1.808a.723.723,0,1,0,.723.723A.724.724,0,0,0,9.127,24.569Zm1.857,4.163H7.27a.179.179,0,0,1-.18-.18,2.037,2.037,0,1,1,4.074,0A.179.179,0,0,1,10.984,28.732ZM7.46,28.371h3.332a1.676,1.676,0,0,0-3.332,0Zm8.363-3.278H11.813a.18.18,0,1,1,0-.361h4.011a.18.18,0,1,1,0,.361Zm0,1.1H11.813a.18.18,0,1,1,0-.361h4.011a.18.18,0,1,1,0,.361Zm0,1.1H11.813a.18.18,0,0,1,0-.361h4.011a.18.18,0,0,1,0,.361Zm0,1.1H11.813a.18.18,0,0,1,0-.361h4.011a.18.18,0,0,1,0,.361Z" transform="translate(-5.772 -20.766)" fill="'+fillColor+'" stroke="'+fillColor+'" stroke-width="0.3"/>\n' +
                    '      <g id="Group_14070" data-name="Group 14070" transform="translate(4.33 1.5)">\n' +
                    '        <path id="Path_10938" data-name="Path 10938" d="M26.21,15.451h-2.4a.506.506,0,0,1-.506-.506v-.69a.506.506,0,0,1,.506-.506h2.4a.506.506,0,0,1,.506.506v.69A.5.5,0,0,1,26.21,15.451Zm-2.4-1.338a.145.145,0,0,0-.145.145v.69a.145.145,0,0,0,.145.145h2.4a.145.145,0,0,0,.145-.145v-.69a.145.145,0,0,0-.145-.145Z" transform="translate(-23.3 -13.75)" fill="'+fillColor+'" stroke="'+fillColor+'" stroke-width="0.3"/>\n' +
                    '      </g>\n' +
                    '      <g id="Group_14071" data-name="Group 14071" transform="translate(5.12)">\n' +
                    '        <path id="Path_10939" data-name="Path 10939" d="M29.21,7.542a.179.179,0,0,1-.18-.18V6.6a.559.559,0,1,0-1.119,0v.762a.18.18,0,1,1-.361,0V6.6a.92.92,0,1,1,1.84,0v.762A.18.18,0,0,1,29.21,7.542Z" transform="translate(-27.55 -5.68)" fill="'+fillColor+'" stroke="'+fillColor+'" stroke-width="0.3"/>\n' +
                    '      </g>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Doctor':
                Icon = '<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26853" data-name="Group 26853" transform="translate(-9312 -11948)">\n' +
                    '    <g id="doctor" transform="translate(9356.984 11988.932)">\n' +
                    '      <path id="Path_12306" data-name="Path 12306" d="M55.695,47.823c-4.232-8.041-8.464-6.771-13.12-7.195A13.047,13.047,0,0,1,43,44.861c6.771,1.693,8.464,9.734,8.464,14.389v4.232H43V59.25H47.23s0-10.58-6.348-10.58-6.348,10.157-6.348,10.58h4.232v4.232H30.3V59.25c0-4.655,1.693-13.12,8.464-14.389a14.707,14.707,0,0,0-.846-5.5,2.858,2.858,0,0,1-1.693-2.539c0-2.539,3.386-1.693,5.925-6.348,0,0,3.809-9.734,2.539-18.2h0a7.779,7.779,0,0,0-.3-2.18,10.056,10.056,0,0,0-.543-1.9v-.15C42.575,3.809,38.343,0,30.3,0S18.029,3.809,16.336,8.464h0a15.761,15.761,0,0,0-.578,2.07c-.109.9-.129.653-.268,2.162h0c-.846,8.464,2.539,18.2,2.539,18.2,2.539,4.232,5.925,3.386,5.925,6.348,0,2.116-2.116,2.963-4.655,3.386-.846.846-1.693,2.539-1.693,5.925v5.079a6.365,6.365,0,0,1,4.232,5.925c0,2.963-2.963,5.925-6.348,5.925a6.509,6.509,0,0,1-6.348-6.348,5.977,5.977,0,0,1,4.232-5.925V46.13a21.442,21.442,0,0,1,.846-5.5c-2.963.423-6.348,1.693-9.311,7.195C2.37,52.479,1.1,67.714,1.1,67.714H59.08c.423,0-.846-15.236-3.386-19.891Z" transform="translate(0)"  fill="'+fillColor+'"/>\n' +
                    '      <path id="Path_12307" data-name="Path 12307" d="M8.232,15.116A2.116,2.116,0,1,1,6.116,13,2.116,2.116,0,0,1,8.232,15.116Z" transform="translate(9.373 42.018)" fill="'+fillColor+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'User':
                Icon = '<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26854" data-name="Group 26854" transform="translate(-9312 -12119)">\n' +
                    '    <circle id="Ellipse_266" data-name="Ellipse 266" cx="75" cy="75" r="75" transform="translate(9312 12119)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="Group_26845" data-name="Group 26845">\n' +
                    '      <g id="Group_26843" data-name="Group 26843" transform="translate(322.872 437.125)">\n' +
                    '        <g id="Group_26844" data-name="Group 26844" transform="translate(9028 11724.451)">\n' +
                    '          <path id="person_4_" data-name="person (4)" d="M19.073,26.468c-.333.016-.667.04-1.267.1C8.89,27.467,0,35.076,0,44.443v8.988H71.9V44.443c0-9.3-8.908-16.865-18.393-17.909-.122-.016-.526-.047-.93-.066-4.853,5.482-9.347,5.019-16.627,5.019S23.927,31.95,19.073,26.468Z" transform="translate(0 11.085)"  fill="'+fillColor+'"/>\n' +
                    '          <circle id="Ellipse_263" data-name="Ellipse 263" cx="19" cy="19" r="19" transform="translate(17.128 0.423)"  fill="'+fillColor+'"/>\n' +
                    '        </g>\n' +
                    '      </g>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Network':
                Icon = '<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26849" data-name="Group 26849" transform="translate(-9607 -11373)">\n' +
                    '    <circle id="Ellipse_267" data-name="Ellipse 267" cx="75" cy="75" r="75" transform="translate(9607 11373)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <path id="Subtraction_7" data-name="Subtraction 7" d="M-8660.631-11598.523h-12.716a1.5,1.5,0,0,1-1.529-1.471v-12.213a1.49,1.49,0,0,1,1.431-1.465h12.946a1.5,1.5,0,0,1,1.4,1.465v12.213A1.5,1.5,0,0,1-8660.631-11598.523Zm-29.813,0h-12.715a1.5,1.5,0,0,1-1.526-1.471v-12.213a1.491,1.491,0,0,1,1.436-1.465h12.9a1.494,1.494,0,0,1,1.438,1.465v12.213A1.5,1.5,0,0,1-8690.444-11598.523Zm-29.809,0h-12.717a1.5,1.5,0,0,1-1.525-1.471v-12.213a1.491,1.491,0,0,1,1.435-1.465h12.9a1.493,1.493,0,0,1,1.437,1.465v12.213A1.5,1.5,0,0,1-8720.253-11598.523Zm25.978-17.613h0l-5.048,0v-7.1h-24.763v7.1h-5.048v-9.527a2.48,2.48,0,0,1,2.524-2.426h27.286v-8.592h-7.946a2.015,2.015,0,0,1-2.051-1.969v-16.377a2.015,2.015,0,0,1,2.051-1.971h20.941a2.014,2.014,0,0,1,2.049,1.971v16.377a2.014,2.014,0,0,1-2.049,1.969h-7.946v8.592h27.286a2.477,2.477,0,0,1,2.521,2.426v9.525l-5.047,0v-7.1h-24.761v7.105Z" transform="translate(18379 23076.344)"  fill="'+fillColor+'"/>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Fire':
                Icon = '<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26857" data-name="Group 26857" transform="translate(-8957 -11849)">\n' +
                    '    <circle id="Ellipse_264" data-name="Ellipse 264" cx="75" cy="75" r="75" transform="translate(8957 11849)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <path id="Path_20450" data-name="Path 20450" d="M68.919,114.61c-10.275-.177-17.855-5.146-22.613-13.92-5-9.228-4.048-18.452,1.977-27.1,1.28-1.837,2.606-3.935,5.2-3.171,2.793.82,2.189,3.478,2.272,5.615.12,3.186-.106,6.408.29,9.555a7.515,7.515,0,0,0,6.571,6.959c3.591.612,6.868-.025,9.194-3.181a7.847,7.847,0,0,0,.162-9.631c-1.923-2.8-4.564-5.1-6.848-7.659-7.828-8.757-4.5-16.6,1.388-24.524,1.751-2.36,4.134-2.164,4.773.9,1.862,8.931,9.039,13.7,14.691,19.726,14.352,15.3,10.13,37.574-8.383,44.97A24.585,24.585,0,0,1,68.919,114.61Z" transform="translate(8962.914 11844.05)"  fill="'+fillColor+'"/>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Heartbeat':
                Icon = '<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26850" data-name="Group 26850" transform="translate(-9607 -11557)">\n' +
                    '    <circle id="Ellipse_268" data-name="Ellipse 268" cx="75" cy="75" r="75" transform="translate(9607 11557)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="cardiogram" transform="translate(9647 11600)">\n' +
                    '      <path id="Path_12304" data-name="Path 12304" d="M35.1,30.829C50.4,17.452,69.844,29.2,70.163,45.139A20.689,20.689,0,0,1,66.739,56.8H51.615l-2.69-4.483a2.055,2.055,0,0,0-3.5-.046l-5.676,8.919L31.48,43.726a2.057,2.057,0,0,0-3.667-.095L20.721,56.8H3.468C-9.312,36.827,15.946,14.073,35.1,30.829Z" transform="translate(0 -25.006)"  fill="'+fillColor+'"/>\n' +
                    '      <path id="Path_12305" data-name="Path 12305" d="M65.784,211.935l5.747-10.672,8.126,17.155a2.057,2.057,0,0,0,3.592.223l5.888-9.253,1.578,2.629a2.055,2.055,0,0,0,1.763,1h13.036c-.409.428,1.769-1.746-26.934,26.809a2.056,2.056,0,0,1-2.9,0c-28.261-28.115-26.526-26.382-26.934-26.809H63.974a2.055,2.055,0,0,0,1.81-1.081Z" transform="translate(-42.026 -177.11)"  fill="'+fillColor+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Security':
                Icon ='<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26851" data-name="Group 26851" transform="translate(-9607 -11759)">\n' +
                    '    <circle id="Ellipse_269" data-name="Ellipse 269" cx="75" cy="75" r="75" transform="translate(9607 11759)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="Group_26846" data-name="Group 26846" transform="translate(333.508 -74.384)">\n' +
                    '      <path id="Subtraction_8" data-name="Subtraction 8" d="M24.859,56.546h0l-.662-.265A39.91,39.91,0,0,1,0,19.556V7.093L24.859,0,49.718,7.093V19.556a39.91,39.91,0,0,1-24.2,36.725l-.662.265ZM24.852,6.895V49.288l.8-.431a33.322,33.322,0,0,0,17.435-29.3V12.1Z" transform="translate(9321 11883)"  fill="'+fillColor+'"/>\n' +
                    '      <path id="Path_20439" data-name="Path 20439" d="M256,7.093V19.556a39.924,39.924,0,0,0,24.2,36.725l.663.265V0Z" transform="translate(9065 11883)"  fill="'+fillColor+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Hospital':
                Icon ='<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26852" data-name="Group 26852" transform="translate(-9607 -11961)">\n' +
                    '    <circle id="Ellipse_270" data-name="Ellipse 270" cx="75" cy="75" r="75" transform="translate(9607 11961)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="Group_26847" data-name="Group 26847" transform="translate(484.601 311.972)">\n' +
                    '      <path id="Subtraction_5" data-name="Subtraction 5" d="M46.3,77H3.7A3.735,3.735,0,0,1,0,73.244V16.9a3.735,3.735,0,0,1,3.7-3.757H16.667V2a2,2,0,0,1,2-2H33.185a2,2,0,0,1,2,2V13.146H46.3A3.735,3.735,0,0,1,50,16.9V73.244A3.735,3.735,0,0,1,46.3,77ZM17.267,50.707a.6.6,0,0,0-.6.6V70.765a.6.6,0,0,0,.6.6H30.881a.6.6,0,0,0,.6-.6V51.307a.6.6,0,0,0-.6-.6ZM28.377,33.8a.6.6,0,0,0-.6.6V42.6a.6.6,0,0,0,.6.6H40.14a.6.6,0,0,0,.6-.6v-8.19a.6.6,0,0,0-.6-.6Zm-20.37,0a.6.6,0,0,0-.6.6V42.6a.6.6,0,0,0,.6.6H19.77a.6.6,0,0,0,.6-.6v-8.19a.6.6,0,0,0-.6-.6Zm20.37-13.146a.6.6,0,0,0-.6.6v8.19a.6.6,0,0,0,.6.6H40.14a.6.6,0,0,0,.6-.6v-8.19a.6.6,0,0,0-.6-.6Zm-20.37,0a.6.6,0,0,0-.6.6v8.19a.6.6,0,0,0,.6.6H19.77a.6.6,0,0,0,.6-.6v-8.19a.6.6,0,0,0-.6-.6ZM21.533,6.4a1.173,1.173,0,0,0-1.163,1.18V8.76a1.173,1.173,0,0,0,1.163,1.18h2.676v2.713a1.173,1.173,0,0,0,1.164,1.18h1.163a1.173,1.173,0,0,0,1.164-1.18V9.94h2.675a1.173,1.173,0,0,0,1.164-1.18V7.58A1.173,1.173,0,0,0,30.374,6.4H27.7V3.686a1.173,1.173,0,0,0-1.164-1.179H25.373a1.173,1.173,0,0,0-1.164,1.179V6.4Z" transform="translate(9172.399 11686.028)"  fill="'+fillColor+'"/>\n' +
                    '      <path id="Rectangle_7797" data-name="Rectangle 7797" d="M1,0H60a1,1,0,0,1,1,1V4a0,0,0,0,1,0,0H0A0,0,0,0,1,0,4V1A1,1,0,0,1,1,0Z" transform="translate(9167.399 11759.028)"  fill="'+fillColor+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Operator':
                Icon = '<svg  xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26858" data-name="Group 26858" transform="translate(-9116 -11849)">\n' +
                    '    <circle id="Ellipse_264" data-name="Ellipse 264" cx="75" cy="75" r="75" transform="translate(9116 11849)" fill="'+ utils.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="call-center_Svg" data-name="call-center Svg" transform="translate(9058.147 11838.974)">\n' +
                    '      <path id="Subtraction_10" data-name="Subtraction 10" d="M62.066,22.4H.071a5.923,5.923,0,0,1-.061-1.28A22.167,22.167,0,0,1,17.948.054,1.8,1.8,0,0,1,18.3.016a1.2,1.2,0,0,1,.76.27A18.868,18.868,0,0,0,30.291,3.87a27.757,27.757,0,0,0,5.093-.316A18.724,18.724,0,0,0,43.075.287,1.25,1.25,0,0,1,43.864,0a1.643,1.643,0,0,1,.322.034,21.907,21.907,0,0,1,13.453,8.4,21.68,21.68,0,0,1,4.484,13.14,4.633,4.633,0,0,1-.058.816Z" transform="translate(101.853 97.488)"  fill="'+fillColor+'"/>\n' +
                    '      <path id="Path_20448" data-name="Path 20448" d="M189.076,137.441a13.047,13.047,0,0,1-6.894-.922,17.627,17.627,0,0,1-7.565-6.2,20.3,20.3,0,0,1-3.646-8.613,16.357,16.357,0,0,1,3.185-13.181,16.617,16.617,0,0,1,29.59,7.565,17.791,17.791,0,0,1-1.278,9.724c-.482,1.132-1.111,2.2-1.677,3.29a.66.66,0,0,1-.356.272c-.9.21-1.823.4-2.724.566a.655.655,0,0,1-.4-.084,4.679,4.679,0,0,0-2.871-.9h-3.206a4.355,4.355,0,0,0-2.766.964,4.515,4.515,0,0,0,.147,7.167A5.149,5.149,0,0,0,189.076,137.441Z" transform="translate(-54.418 -40.296)"  fill="'+fillColor+'"/>\n' +
                    '      <path id="Path_20449" data-name="Path 20449" d="M167.212,90.5a17.245,17.245,0,0,1-3.583,2.012,24.651,24.651,0,0,1-6.915,1.739h-.063a1.369,1.369,0,0,0-1.236.587,2.144,2.144,0,0,1-1.823.838H150.3a2.483,2.483,0,0,1-.021-4.967c1.09-.021,2.2,0,3.29,0a2.523,2.523,0,0,1,1.991.943.571.571,0,0,0,.335.168,20.427,20.427,0,0,0,9.409-3.08.354.354,0,0,0,.189-.482A4.252,4.252,0,0,1,165.305,87c-.021-2.745-.021-5.511,0-8.257a4.023,4.023,0,0,1,2.1-3.625.311.311,0,0,0,.189-.356,20.888,20.888,0,0,0-2.6-8.885,21.265,21.265,0,0,0-31.958-6.329,20.587,20.587,0,0,0-3.9,4.086,26.417,26.417,0,0,0-1.572,2.515,20.923,20.923,0,0,0-2.452,8.592.285.285,0,0,0,.168.335,4.037,4.037,0,0,1,2.117,3.688v8.11a4.183,4.183,0,0,1-2.724,4,4.35,4.35,0,0,1-4.82-1.257,3.925,3.925,0,0,1-.943-2.452c-.021-2.892-.042-5.8,0-8.7a3.873,3.873,0,0,1,2.117-3.395.431.431,0,0,0,.251-.4,23.147,23.147,0,0,1,.65-4.485,24.909,24.909,0,0,1,9.263-14.082,24.249,24.249,0,0,1,11.945-4.883,25.157,25.157,0,0,1,27.054,17.079,23.78,23.78,0,0,1,1.216,6.412.341.341,0,0,0,.23.356,4.083,4.083,0,0,1,2.159,3.709c0,2.682-.021,5.365,0,8.047a4.249,4.249,0,0,1-6.413,3.751C167.338,90.586,167.3,90.544,167.212,90.5Z" transform="translate(-13.463)"  fill="'+fillColor+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'None':
                Icon = "";
                break;
            default:
                Icon = "";
        }
        return Icon;
    },
    broadcastMemberClick: function(){
        $(".remove-broadcast-cnt-link").click(function () {
            let name;
            let id = $(this).closest('.sideBar-body').attr('id');
            let result = id.split(/-(.+)/);
            name = $(this).closest('.sideBar-body').find('.broadcastNameMeta').text();
            let broadCastInfo = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

            let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
            let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);
            let memberJid = result[1];
            let broadcastRmvUserInfo = {};
            broadcastRmvUserInfo[0] = [];
            broadcastRmvUserInfo[0].push(memberJid);
            broadcastRmvUserInfo[0].push(name);
            broadcastRmvUserInfo[0].push(nodeJid);
            
            webEncrypt.encryptAndStoreInLocalStorage('broadcastRmvUserInfo', broadcastRmvUserInfo);
            let content = language.locali().remove + ' ' + minEmoji(name) + ' from ' + minEmoji(broadCastInfo[nodeJid][1]) + ' ?';
            $("#remove-broadcast-cnt").find('.popup-mute').html(content);
            $("#remove-broadcast-cnt").addClass("open");
        });
    },
    groupmemberclick: function () {
        $(".remove-grp-cnt-link").click(function () {
            let name;
            let id = $(this).closest('.sideBar-body').attr('id');
            let result = id.split(/-(.+)/);
            name = $(this).closest('.sideBar-body').find('.contactname').text();
            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
            let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
            let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);
            let memberJid = result[1];
            let adminUserInfo = {};
            adminUserInfo[0] = [];
            adminUserInfo[0].push(memberJid);
            adminUserInfo[0].push(name);
            webEncrypt.encryptAndStoreInLocalStorage('adminUserInfo', adminUserInfo);
            let content = language.locali().remove + ' ' + minEmoji(name) + ' from ' + minEmoji(groupInfo[nodeJid][1]) + ' ?';
            $("#remove-grp-cnt").find('.popup-mute').html(content);
            $("#remove-grp-cnt").addClass("open");
        });
        $(".make-grp-admin-link").click(function () {
            let name;
            let id = $(this).closest('.sideBar-body').attr('id');
            let result = id.split(/-(.+)/);
            name = $(this).closest('.sideBar-body').find('.contactname').text();
            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
            let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
            let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);
            let memberJid = result[1];
            let adminUserInfo = {};
            adminUserInfo[0] = [];
            adminUserInfo[0].push(memberJid);
            adminUserInfo[0].push(name);
            webEncrypt.encryptAndStoreInLocalStorage('adminUserInfo', adminUserInfo);
            let content = 'Make ' + minEmoji(name) + ' an admin for ' + groupInfo[nodeJid][1] + ' ?';
            $("#make-grp-admin").find('.popupcontent').html(content);
            $("#make-grp-admin").addClass("open");
        });
    },
    getReplyMessage: function (grmsgid, replyTo, chatType) {
        let getReplymessage = stropheConnection
            .StropheJs()
            .$iq({
                type: "get",
                id: utils.getId(),
                to: stropheConnection.Server()
            })
            .c("query", {
                xmlns: "jabber:iq:user_activities",
                status: "reply_message",
                chat_type: chatType,
                message_id: grmsgid,
                reply_id: replyTo
            });

        if (stropheConnection.Connection().connected) {

            stropheConnection.Connection()
                .sendIQ(getReplymessage, module.exports.replyMessageCallBack);
        }
    },
    replyMessageCallBack: function (replyMessage) {

        if ($(replyMessage).find('chat').length) {
            let messageFrom = $(replyMessage).find('chat').find('replyfromuser').text();
            let rmsgid = $(replyMessage).find('chat').find('msgid').text();
            let chatType = $(replyMessage).find('chat').find('chat_type').text();
            let rmsgbody = $(replyMessage).find('chat').find('body').text();
            let oldmsgid;
            let ReplyMsgId = webEncrypt.getFromLocalStorageAndDecrypt('ReplyMsgId');

            if (ReplyMsgId == '') {
                oldmsgid = $(replyMessage).find('replymessage').attr('id');
            } else {
                oldmsgid = ReplyMsgId;
            }

            let replymessageContent = '';

            try {
                replymessageContent = JSON.parse(utils.decrypt(rmsgbody, rmsgid));
            }
            catch (err) {
                console.log(err);
            }

            let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
            if (chatType == 'normal') {
                messageFrom = stropheConnection.Strophe().getNodeFromJid(messageFrom);
            }else { // Reply Message Handling in both Single Chat & Broadcast
                let toid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
                toid = stropheConnection.Strophe().getNodeFromJid(toid);
               
                rmsgid = module.exports.getSingleAndBroadcastReplyMsgId(replyMessage,toid);
            }
            
            let profilename = module.exports.replyMessageCallBackProfileName(loginUserInfo,messageFrom,chatType);
            let replymessageBodyContent = utils.getreplymessage(replymessageContent, rmsgid, profilename);

            module.exports.replyMessageBodyContentAppend(oldmsgid,rmsgid,replymessageBodyContent)
            module.exports.Replyclick();
        }
    },
    getSingleAndBroadcastReplyMsgId: function(replyMessage,toid){
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

        let rmsgid;
        if (broadcastProfile != null && typeof broadcastProfile[toid] != "undefined" && broadcastProfile[toid][0] == 'broadcast') {
            let broadcastId = $(replyMessage).find('chat').find('broadcastmsg_id').text();
            if(broadcastId){
                rmsgid = $(replyMessage).find('chat').find('broadcastmsg_id').text();
            }
        }else{
            let broadcastmsg_id = $(replyMessage).find('chat').find('broadcastmsg_id').text();
            let msgid = $(replyMessage).find('chat').find('msgid').text();

            if(broadcastmsg_id != '' && $('[data-broadcastmsgid="'+broadcastmsg_id+'"]').length > 0){
                rmsgid = $('[data-broadcastmsgid="'+broadcastmsg_id+'"]').attr('id').split('-')[1];
            }else {
                rmsgid = msgid;
            }
        }

        return rmsgid;
    },
    replyMessageCallBackProfileName: function(loginUserInfo,messageFrom,chatType){
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let profilename;
        if (loginUserInfo[0][0] == messageFrom || chatType == 'broadcast') {
            profilename = 'You';
        } else {
            if (typeof userInfo[messageFrom] != "undefined") {
                profilename = utils.toTitleCase(userInfo[messageFrom][1]);
            } else {
                profilename = messageFrom;
            }
        }
        return profilename;
    },
    replyMessageBodyContentAppend: function(oldmsgid,rmsgid,replymessageBodyContent) {
        if ($("#chat-" + oldmsgid).find('#replycontent-' + rmsgid).length == 0) {
            if ($("#chat-" + oldmsgid).find('.sender').length) {
                $("#chat-" + oldmsgid).find('.sender').prepend(replymessageBodyContent[1]);
            }
            else if ($("#chat-" + oldmsgid).find('.receiver').length) {
                $("#chat-" + oldmsgid).find('.receiver').prepend(replymessageBodyContent[1]);
            }
        }
    },
    Replyclick: function () {
        $(".replycontent").off("click");
        $(".replycontent").unbind("click");
        $(".replycontent").click(function () {
            let tojid = stropheConnection.Strophe().getNodeFromJid(utils.toJID());
            let result = $(this).attr("id").split("-");
            let replyMessageId = webEncrypt.getFromLocalStorageAndDecrypt('ReplyMsgId');

            if (typeof replyMessageId != "undefined") {

                $("#chat-" + replyMessageId).css("background-color", "");
            }
            replyMessageId = result[1];
            if (typeof replytimer != "undefined") {
                clearTimeout(replytimer);
            }

            if ($("#chat-" + replyMessageId).length) {

                $(".message-body").css("background-color", "");
                let container = $( "[id='conversation"+tojid+"']"),
                    scrollTo = $("#chat-" + replyMessageId);

                let pos = scrollTo.offset() ? scrollTo.offset().top - container.offset().top + container.scrollTop() : container.offset().top + container.scrollTop();
                container.animate({
                    scrollTop: pos
                }, {
                    duration: 800, // Duration in milliseconds
                    easing: 'swing', // Easing option
                    complete: function() {
                        // Optional: Callback function after animation completes
                        console.log('Animation completed!');
                    }
                });
                
                $("#chat-" + replyMessageId).css("background-color", "rgb(218, 218, 218)");
                replytimer = setTimeout(function () {
                    $("#chat-" + replyMessageId).css("background-color", "");
                }, 2000);

            } else {
                let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
                let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

                let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
                if (broadcastProfile != null && typeof broadcastProfile[tojid] != "undefined" && broadcastProfile[tojid][0] == 'broadcast') {
                    scrollposition = "";
                    scrollup_page = false;
                    scrolldown_page = false;
                    $(".downarrow").hide();
                    module.exports.pagedownClick();
                    module.exports.getBroadcastChat(utils.toJID(), scrollposition, replyMessageId);

                } else if (groupInfo != null && typeof groupInfo[tojid] != "undefined") {
                    scrollposition = "";
                    scrollup_page = false;
                    scrolldown_page = false;
                    $(".downarrow").hide();
                    module.exports.pagedownClick();
                    module.exports.getGroupChat(utils.toJID(), scrollposition, replyMessageId);

                } else if (userInfo != null && typeof userInfo[tojid] != "undefined") {
                    scrollposition = "";
                    scrollup_page = false;
                    scrolldown_page = false;
                    $(".downarrow").hide();
                    module.exports.pagedownClick();
                    module.exports.getSingleChat(utils.toJID(), scrollposition, replyMessageId);

                }
                setTimeout(function () {
                    $("#chat-" + replyMessageId).css("background-color", "rgb(218, 218, 218)");
                    replytimer = setTimeout(function () {
                        $("#chat-" + replyMessageId).css("background-color", "");
                    }, 2000);
                }, 1000);
            }
            return true;
        });
    },
    pagedownClick: function () {
        $(".downarrowscroll").off("click");
        $(".downarrowscroll").click(function () {
            module.exports.MessageLayout(utils.toJID(), 'down', '');
        });

    },
    sendSeenStatus: function (from, msgid, msgPriority,msg_ack, divJid,broadcast_msgid) {
        let randomValue = utils.cryptoRandomGenerate();
        let messageid = randomValue.toString(36).replace(/[^a-z]+/g, '').substring(0, 9);
        let groupId = '';
        let toUserId;
        let seenackmessage;
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
        let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);

        if(groupInfo != null && typeof groupInfo[nodeJid] != "undefined") {
            groupId =  nodeJid.split('@')[0];
            toUserId = '';
            seenackmessage = stropheConnection.StropheJs().$msg({
                to: from + "@" + stropheConnection.Server(),
                type: "chat",
                id: messageid
            }).c('seen', {
                xmlns: 'urn:xmpp:receipts',
                group_id: groupId + "@mix." + stropheConnection.Server(),
                id: msgid,
                message_priority: msgPriority,
                to_user : toUserId
            });
        }else {
            toUserId = from;
            seenackmessage = stropheConnection.StropheJs().$msg({
                to: from + "@" + stropheConnection.Server(),
                type: "chat",
                id: messageid
            }).c('seen', {
                xmlns: 'urn:xmpp:receipts',
                id: msgid,
                message_priority: msgPriority,
                to_user : toUserId,
                broadcastmsg_id:broadcast_msgid
            });
        }
        
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().send(seenackmessage);
            $('#chat-' + msgid).attr('data-status', 2);
        }
    },
    sendDeliverStatus: function (from, msgid) {
        let randomValue = utils.cryptoRandomGenerate();

        let messageid = randomValue.toString(36).replace(/[^a-z]+/g, '').substring(0, 9);
        let groupId = '';
        let groupid = stropheConnection.Strophe().getNodeFromJid(utils.toJID());
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let tojid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
        let nodeJid = stropheConnection.Strophe().getNodeFromJid(tojid);

        if(groupInfo != null && typeof groupInfo[nodeJid] != "undefined") {
            groupId = groupid;
        }
        let recackmessage = stropheConnection.StropheJs().$msg({
            to: stropheConnection.Strophe().getBareJidFromJid(from),
            type: 'chat',
            id: messageid
        }).c('received', {
            xmlns: 'urn:xmpp:receipts',
            group_id: groupId ,
            id: msgid
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().send(recackmessage);
            $('#chat-' + msgid).attr('data-status', 2);
        }
    },
    // highlight priority messages
    priorityMessageClick(messageId) {
        let tojid = stropheConnection.Strophe().getNodeFromJid(utils.toJID());
        if (typeof replytimer != "undefined") {
            clearTimeout(replytimer);
        }

        if ($("#chat-" + messageId).length) {
            $(".message-body").css("background-color", "");
            let container = $("[id='conversation"+tojid+"']"),
                scrollTo = $("#chat-" + messageId);

            let pos = scrollTo.offset() ? scrollTo.offset().top - container.offset().top + container.scrollTop() : container.offset().top + container.scrollTop();
            container.animate({
                scrollTop: pos
            });

            $("#chat-" + messageId).css("background-color", "rgb(218, 218, 218)");
            replytimer = setTimeout(function () {
                $("#chat-" + messageId).css("background-color", "");
            }, 2000);

        } else {
            let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
            let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
            if (broadcastProfile != null && typeof broadcastProfile[tojid] != "undefined" && broadcastProfile[tojid][0] == 'broadcast') {
                scrollposition = "";
                $(".downarrow").hide();
                module.exports.pagedownClick();
                module.exports.getBroadcastChat(utils.toJID(), scrollposition, messageId);

            } else if (groupInfo != null && typeof groupInfo[tojid] != "undefined") {
                scrollposition = "";
                $(".downarrow").hide();
                module.exports.pagedownClick();
                module.exports.getGroupChat(utils.toJID(), scrollposition, messageId);

            } else if (userInfo != null && typeof userInfo[tojid] != "undefined") {
                scrollposition = "";
                $(".downarrow").hide();
                module.exports.pagedownClick();

                module.exports.getSingleChat(utils.toJID(), scrollposition, messageId);
                
            }
            setTimeout(function () {
                $("#chat-" + messageId).css("background-color", "rgb(218, 218, 218)");
                replytimer = setTimeout(function () {
                    $("#chat-" + messageId).css("background-color", "");
                }, 2000);
            }, 1000);
        }
        return true;
    }
};